import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import {InputText} from 'primereact/inputtext';

import {Button} from 'primereact/button';
import {Dropdown} from 'primereact/dropdown';
import {InputSwitch} from 'primereact/inputswitch';
import {Steps} from 'primereact/steps';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {InputMask} from 'primereact/inputmask';
import {Calendar} from 'primereact/calendar';
import {RadioButton} from 'primereact/radiobutton';
import { MultiSelect } from 'primereact/multiselect';
import { Dialog } from 'primereact/dialog';
import axios from '../../../axios-url';
import UploadImage from '../../../assets/images/uploadImg.svg';
import { FileUpload } from 'primereact/fileupload';
import moment from 'moment';



import { DROPDOWN_CONFIG, EMPLOYEE_SUBMENU_ID } from '../../../shared/Config';
import { HASACCESS, UPLOAD_NAME_CONCAT } from '../../../shared/utility';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import {Toast} from 'primereact/toast';
import Messages from '../../../shared/UI/Messages/Messages';
import * as actions from '../../../store/actions/index';
import Attachments from '../../../shared/UI/Attachments/Attachments';
import { id } from 'chart.js/src/plugins/plugin.filler';

const weekdayOptions = [
    { label: 'Sunday', value: 'Sunday' },
    { label: 'Monday', value: 'Monday' },
    { label: 'Tuesday', value: 'Tuesday' },
    { label: 'Wednesday', value: 'Wednesday' },
    { label: 'Thursday', value: 'Thursday' },
    { label: 'Friday', value: 'Friday' },
    { label: 'Saturday', value: 'Saturday' }
];


const currencyList = [
    {"label":"INR","value":"INR","id":"INR"},
    {"label":"KWD","value":"KWD","id":"KWD"},
    {"label":"SAR","value":"SAR","id":"SAR"},
    {"label":"USD","value":"USD","id":"USD"},
    { "label": "AED", "value": "AED", "id": "AED" },
    {"label":"EUR","value":"EUR","id":"EUR"},
    {"label":"OMR","value":"OMR","id":"OMR"},
    {"label":"BHD","value":"BHD","id":"BHD"},
    {"label":"GBP","value":"GBP","id":"GBP"},
    {"label":"CAD","value":"CAD","id":"CAD"},
    {"label":"CHF","value":"CHF","id":"CHF"},
    {"label":"DZD","value":"DZD","id":"DZD"},
    { "label": "IQD", "value": "IQD", "id": "IQD" },
    {"label":"JOD","value":"JOD","id":"JOD"},
    {"label":"PKR","value":"PKR","id":"PKR"},
    {"label":"PHP","value":"PHP","id":"PHP"},   
    { "label": "JPY", "value": "JPY", "id": "JPY" }]; 



const WEEKLY_OFF_OPTIONS = [
    { id: 1, label: "One day" },
    { id: 2, label: "Two day" },
    { id: 3, label: "Three day" },
    { id: 4, label: "No weekly Off" }
];

class AddEmployeeMaster extends Component {
    state = {
        Middlename:"",
        DateOfBirth:"",
        DateOfJoin: "",
        Confirmationdate: "",
        Appointmentletterdt: "",
        FirstnameAr:"",
        MiddlenameAr:"",
        Lastname:"",
        LastnameAr: "",
        EmployeeGradeNo:"",
        display : true,
        dropdownEmployee: null,
        nationality: null,
        nationalityArabic: "",
        Costcenter: "",
        BupaId: "",
        Iqama: "",
        terminationDate: "",
        Gender: "1",
        nationalities:[
            {label:'Indian', value: 'indian'},
            {label:'Emirati', value: 'emmirati'},
            {label:'Saudi', value: 'saudi'}
        ],
        nationId:"",
        inputSwitchValue: false,
        roles : [],
        activeIndex:0,
        stepsItems : [
            {
                label: 'Personal',
                command: (event) => {
                    //this.growl.show({severity:'info', summary:'First Step', detail: event.item.label});
                }
            },
            {
                label: 'Dependents',
             
            },
            {
                label: 'Position & Org',
             
            },
            {
                label: 'Documents',
             
            },
            {
                label: 'Leave Quota',
            
            },
            // {
            //     label: 'Ticket Quota',
            
            // },
            // {
            //     label: 'Visa Quota',
            
            // },
            {
                label: 'PO',
            
            },
            {
                label: 'Allowance & Deduction',
            },

            {
                label: 'Statutory & Bank',
            
            },
            
        ],
        employeeType: [
            {label : 'Permanent',value : 1},
            {label : 'Contract',value : 2}
        ],
        // statusType: [
        //     {label: 'Select Status', value: null},
        //     {label: 'Terminated', value: '1'},
        //     {label : 'On Vacation',value : '2'},
        //     { label: 'On Medical Leave', value: '4' },
        //     { label: 'Active', value: '3' },
        //     {label : 'Resigned',value : '0'}
        // ],
        status: null,
        selectedType:null,
       
        isActive : true,
        ContractorId:'',
        EmployeeNo:'',
        Employeetypeid : null,
        Firstname : '',
        EmpGroupId : '',
        VendorId: '',
        grade: '',
        companyId: '',
        shiftpatternId:'',
        persarea:'',
        perssubarea: '',
        empgrp: '',
        empsubgrp: '',
        payrollarea: '',
        workrule: '',
        paytype: '',
        payarea: '',
        paygroup: '',
        paylevel: '',
        project: '',
        vendortimesheetemail: '',
        profession: '',
        catagory: '',
        salarytype:'',
        contractype: '',
        cardno:'',
        address: '',
        visastatus: '',
        visatype: '',
        probationperiod: '',
        sponsor: '',
        apcocardno: '',
        apcocardexpirydate: '',
        religion: '',
        hourlyrate: '',
        agreement: '',
        saudinonsaudi: '',
        apcomobilenumber: '',
        agreementexpirydate: '',
        campallotted: '',
        seniority: '',
        demobilizestatus: "0",
        fatherName: '',
        workLocation: '',
        dailyWorkHours: '',
        breakTime: '',
        noticePeriod: '',
        weeklyOff: null,

        depTypes : [],
        approvals : [],
        dependentDetails : [],
        poDetails : [],
        leaveQuota : [],
        leaveType : null,
        used : '',
        balance: '',
        allocated: '',
        usedt : '',
        balancet: '',
        allocatedt: '',     
        Yeart:'',
        YearL:'',
        type : 'add',
        createdBy : (this.props.loggedUserDetail.userName) ?? 'Admin',
        createdDate : new Date(),
        CompanyId: this.props.loggedUserDetail.CompanyId,
        loadOnce : true,
        profilePicUrl:false,
        TicketType: null,
        TicketQuota : [],
        usedQuota : '',
        balanceQuota : '',
        visaType: null,
        VisaQuota : [],
        YearV : '',
        allocatedV : '',
        usedV : '',
        balanceV: '',
        positionEn:'',
        poData: [],
        selectedPosition:'',
        employeePostionId:'',
        employeeId:'',
        executives:'',
        isExecutive:'',
        selectedVicePresident:'',
        isPresident:'',
        selectedDivision:'',
        isDivision:'',
        selectedDepartment:'',
        isDepartment:'',
        selectedSection:'',
        isSection:'',
        selectedUNC:'',
        isUnc:'',

    documentForm:{
        DocType: '',
        DocDocumentType: '',
        DocDocumentNo: '',
        DocExpiryDate: '',
        DocIssuDate: '',
        DocIssuPlace: '',
        Expiryarabic: '',
        Attachment: null
    },
    showAttachmentDialog: false,
    previewDocument: null,
    showPreviewModal: false,
    requestattachments:[],

    // Bank Details
    bankName: '',
    branchName: '',
    accountHolderName: '',
    accountNumber: '',
    ifscCode: '',
    ibannumber: '',
    upiId: '',
    salaryAccountType: '',

    // Statutory & Compliance Details
    panNumber: '',
    aadhaarNumber: '',
    uanNumber: '',
    pfNumber: '',
    esiNumber: '',
    ptState: '',
    lwfApplicability: '',
    taxRegime: '',
    tanLocation: '',
    form12bSubmitted: '',
    prevEmpIncome: '',
    prevEmpTax: '',
    gratuityNumber: '',

    // Deduction Components
    pfPercentage: '',
    esiPercentage: '',
    ptPercentage: '',
    tdsPercentage: '',

    //allowance& deduction
        allowanceDeductionDetails: {
            selectedAllowanceDeduction: null,
            allowanceDeductionAmount: '',
            allowanceDeductionDescription: '',
            allowanceDeductionUnit: ''
        },
        allowanceDeductionQuota: [],

    



    }



    
  
//Attachment 
    handleChange = (e) => {

        const { name , value } = e.target;

        this.setState({[name]: value});
    }
    
    // handlePoChange = (e) => {
        
    //     this.setState((prevState) => ({
    //         po: {
    //             ...prevState.po,
    //             holiday: e.value
    //         }
    //     }));
    // };

    //new function for multiselect & switch in poDetails
    handlePoChange = (e, id) => {
        const { name, value } = e.target ? e.target : e;
        const newPoDetails = this.state.poDetails.map(po =>
            po.employeePoId === id ? { ...po, [name]: value } : po
        );
        this.setState({ poDetails: newPoDetails });
    }
    statusBodyTemplate = (rowData) => {
        return <span className="">{rowData.status}</span>;
    }


    // documentAdd = () => {

    //     let newDoc = {depType : "own", documentType:"---Select---",doucmentNo:"",expiryDate:"",issuedDate:"",issuedPlace:""};
  
    //     let docValue = [...this.state.depTypes, newDoc];
      
    //     this.setState({depTypes:docValue})
    // }

    // To capture Attachment
    

    documentAdd = () => {  // new Document Add For new fourthgrid
    let newDoc = { ...this.state.documentForm };
    let docValue = [...this.state.depTypes, newDoc];
    this.setState({
        depTypes: docValue,
        documentForm: {
            DocType: '',
            DocDocumentType: '',
            DocDocumentNo: '',
            DocExpiryDate: '',
            DocIssuDate: '',
            DocIssuPlace: '',
            Expiryarabic: '',
            Attachment: null
        }
    });
}

    handleDocumentAttachment = (e) => {
    // Handle both FileUpload component event and input change event
    const file = e.files ? e.files[0] : e.target.files[0];
    if (!file) return;

    // Validate file size (max 10MB)
    const maxSize = 10 * 1024 * 1024; // 10MB
    if (file.size > maxSize) {
        this.growl.show({ 
            severity: 'warn', 
            summary: 'File Too Large', 
            detail: 'Maximum file size is 10MB' 
        });
        return;
    }

    this.setState({ loading: true });
    
    // Generate filename using same convention as Attachments component
    const fileName = 'Attachments_' + UPLOAD_NAME_CONCAT + '_' + file.name;
    const frmData = new FormData();
    frmData.append('file', file, fileName);
    
    // Upload to server
    axios.post(`/master/api/upload?FolderName=EmployeeDocument`, frmData)
        .then(response => {
            console.log('Upload response:', response);
            
            if (response.status === 200 && response.data) {
                const attachmentObj = {
                    fileExtension: response.data.fileExtention || response.data.fileExtension || '',
                    filePath: response.data.filePath || '',
                    fileName: response.data.fileName || file.name,
                    virtualFilePath: response.data.virtualFilePath || '',
                    folderName: 'EmployeeDocument'
                };
                
                this.setState({
                    documentForm: {
                        ...this.state.documentForm,
                        Attachment: attachmentObj
                    },
                    loading: false
                }, () => {
                    this.growl.show({ 
                        severity: 'success', 
                        summary: 'Success', 
                        detail: 'File uploaded successfully: ' + attachmentObj.fileName
                    });
                });
            } else {
                throw new Error('Invalid response from server');
            }
        })
        .catch(err => {
            console.error('Upload error:', err);
            this.setState({ loading: false });
            
            let errorMessage = 'File upload failed';
            if (err.response && err.response.data && err.response.data.message) {
                errorMessage = err.response.data.message;
            } else if (err.message) {
                errorMessage = err.message;
            }
            
            this.growl.show({ 
                severity: 'error', 
                summary: 'Upload Error', 
                detail: errorMessage
            });
        });
};


     /* Cell Editing */

    // typeEditor = (props) => {
    //     let types = [
    //         {label:'Own',value:'Own'},
    //         {label:'Dependent',value:'Dependent'}
    //     ];

    //     return (
    //         <Dropdown value={props.value[props.rowIndex].depType} options={types}
    //              onChange={(e) => this.onEditorValueChange(props, e.value)} style={{width:'100%'}} placeholder="---Select---"/>
    //     );
    // }

    typeEditor = (props) => {
        let types = [
            { label: 'Own', value: 'Own' },
            { label: 'Dependent', value: 'Dependent' }
        ];
    
        return (
            <Dropdown
                value={props.rowData?.DocType || ''}  // Use props.rowData instead of props.value
                options={types}
                onChange={(e) => this.onEditorValueChange(props, e.value)}
                autoFocus  // Ensure the dropdown gets focus when clicked
                style={{ width: '100%' }}
                placeholder="---Select---"
            />
        );
    };


    docTypeEditor = (props) => {
        let types = [
            // {label:'Passport',value:'Passport'},
            // {label:'Driving License',value:'Driving License'},
            // {label:'Iqama',value:'Iqama'}
            { label: 'Aadhaar Card', value: '1' },
            { label: 'PAN Card', value: '2' },
            { label: 'Driving License', value: '3' },
            { label: 'Voter ID', value: '4' },
            { label: 'Ration Card', value: '5' },
            { label: 'Educational Certificate', value: '6' },
            { label: 'Passport', value: '7' },
            { label: 'Birth Certificate', value: '8' },
            { label: 'Marriage Certificate', value: '9' },
            { label: 'Address Proof', value: '10' },
            { label: 'Experience Certificate', value: '11' },
            { label: 'Relieving Letter', value: '12' },
            { label: 'Offer Letter', value: '13' },
            { label: 'Appointment Letter', value: '14' },
            { label: 'Employee ID Card', value: '15' },
            { label: 'Medical Insurance Card', value: '16' },
            { label: 'Police Verification', value: '17' },
            { label: 'ESI Card', value: '18' },
            { label: 'PF Declaration Form', value: '19' },
            { label: 'Form 16', value: '20' },
            { label: 'Form 12B', value: '21' },
            { label: 'Non Disclosure Agreement (NDA)', value: '22' },
            { label: 'Employment Contract', value: '23' },
            { label: 'Iqama',value:'24'},
            { label: 'Other', value: '99' }
        ];

        return (
            <Dropdown value={props.rowData.DocDocumentType} options={types}
                    onChange={(e) => this.onEditorValueChange(props, e.value)} style={{width:'100%'}} placeholder="---Select---"/>
        );
    }

   
    // onEditorValueChange = (props, value) => {
    //     let updatedValue = [...props.value];
    //     updatedValue[props.rowIndex][props.field] = value;
    //     this.setState({depType: updatedValue});
    // }

    onEditorValueChange = (props, value) => {
        let updatedDepTypes = [...this.state.depTypes];  // Clone state
        updatedDepTypes[props.rowIndex] = {
            ...updatedDepTypes[props.rowIndex],
            [props.field]: value
        };
    
        this.setState({ depTypes: updatedDepTypes });  // Update entire depTypes array
    };
    // onEditorValueChange = (props, value) => {
    //     let updatedDepTypes = [...this.state.depTypes];  // Clone the state array
    //     updatedDepTypes[props.rowIndex] = {
    //         ...updatedDepTypes[props.rowIndex],
    //         depType: value  // Ensure correct field update
    //     };
    
    //     this.setState({ depTypes: updatedDepTypes }, () => {
    //         console.log("Updated depTypes:", this.state.depTypes); // Debugging
    //     });
    // };

    // onEditorValueChangedoctype = (props, value) => {
    //     let updatedDepTypes = [...this.state.depTypes];  // Clone the state array
    //     updatedDepTypes[props.rowIndex] = {
    //         ...updatedDepTypes[props.rowIndex],
    //         documentType: value  // Ensure correct field update
    //     };
    
    //     this.setState({ depTypes: updatedDepTypes }, () => {
    //         console.log("Updated depTypes:", this.state.depTypes); // Debugging
    //     });
    // };

    


    onEditorPoValueChange = (props, value) => {
        const updatedPOData = [...this.state.poData];
        updatedPOData[props.rowIndex][props.field] = value;
        this.setState({ poData: updatedPOData });
    };
    
    inputTextEditor = (props, field) => {
        return <InputText type="text" value={props.rowData[field]} onChange={(e) => this.onEditorValueChange(props, e.target.value)} />;
    }

    inputCalendarEditor = (props, field) => {
        return <InputMask mask="99/99/9999" slotChar="dd/mm/yyyy" placeholder="Date" value={props.rowData[field]} onChange={(e) => this.onEditorValueChange(props, e.target.value)} />
        
    }

    issuedEditor =  (props) => {
        return this.inputCalendarEditor(props, 'DocIssuDate');
    }
    
    
    expiryEditor =  (props) => {
        return this.inputCalendarEditor(props, 'DocExpiryDate');
    }
    HijriDateEditor =  (props) => {
        return this.inputCalendarEditor(props, 'Expiryarabic');
    }

    noEditor =  (props) => {
        return this.inputTextEditor(props, 'DocDocumentNo');
    }

    placeEditor =  (props) => {
        return this.inputTextEditor(props, 'DocIssuPlace');
    }
    
    inputPoTextEditor = (props, field) => {
        return <InputText type="text" value={props.rowData[field]} onChange={(e) => this.onEditorPoValueChange(props, e.target.value)} />;
    };
    
    datePoEditor = (props, field) => {
        return <Calendar value={props.rowData[field]} onChange={(e) => this.onEditorPoValueChange(props, e.value)} />;
    };
    

    deleteDocType = (removeIndex) => {

        const updatedDeptValue = this.state.depTypes.filter((value,index) => {
            return removeIndex !== index;
        })
        this.setState({depTypes:updatedDeptValue})

    }

    downloadDocument = (rowData) => {
        if (!rowData.Attachment) {
            this.growl.show({ 
                severity: 'warn', 
                summary: 'Warning', 
                detail: 'No attachment found' 
            });
            return;
        }

        this.setState({ loading: true });
        
        const { fileName, fileExtension } = rowData.Attachment;
        
        axios({
            url: `/master/api/Download?filename=${fileName}&&FolderName=EmployeeDocument&&ext=${fileExtension}`,
            method: 'GET',
            responseType: 'blob'
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${fileName}${fileExtension}`);
            document.body.appendChild(link);
            link.click();
            this.setState({ loading: false });
        }).catch(err => {
            this.setState({ loading: false });
            this.growl.show({ 
                severity: 'error', 
                summary: 'Error', 
                detail: 'File download failed' 
            });
        });
    }
    
    deletePOEntry = (index) => {
    const updatedPOData = this.state.poData.filter((_, i) => i !== index);
    this.setState({ poData: updatedPOData });
};


    deleteApproval  = (removeIndex) => {

        const updatedDeptValue = this.state.approvals.filter((value,index) => {
            return removeIndex !== index;
        })
        this.setState({approvals:updatedDeptValue})

    }
    // requiredValidator = (props) => {
    //     let value = props.rowData[props.field];
    //     return value && value.length > 0;
    // }

    actionQuota = (rowData, column) => {
        let rowIndex = column.rowIndex;
        return <div className="actionCenter">
                <Button onClick={() => this.deleteLeave(rowIndex)} icon="pi pi-trash"  className="p-button-danger"/>
            </div>;
    }
    
    actionTQuota = (rowData, column) => {
        let rowIndex = column.rowIndex;
        return <div className="actionCenter">
                <Button onClick={() => this.deleteTicket(rowIndex)} icon="pi pi-trash"  className="p-button-danger"/>
            </div>;
    }
    
    actionVQuota = (rowData, column) => {
        let rowIndex = column.rowIndex;
        return <div className="actionCenter">
                <Button onClick={() => this.deleteVisa(rowIndex)} icon="pi pi-trash"  className="p-button-danger"/>
            </div>;
    }

    actionTemplate = (rowData, column) => {
        let rowIndex = column.rowIndex;
        return <div>
            <Button type="button" icon="pi pi-trash" className="p-button-danger" onClick={() => this.deleteDocType(rowIndex)}></Button>
        </div>;
    }


    prevMove = () => {

        let currentIndex = this.state.activeIndex;

        let prevValue = currentIndex - 1;

        this.setState({activeIndex:prevValue})

    }

    nextMove = () => {
        let currentIndex = this.state.activeIndex;

        let prevValue = currentIndex + 1;

        this.setState({activeIndex:prevValue})
    }


    // Add Allowance/Deduction Entry
        addAllowanceDeduction = () => {
            let newEntry = {
                allowanceType: this.state.allowanceDeductionDetails.selectedAllowanceDeduction,
                amount: this.state.allowanceDeductionDetails.allowanceDeductionAmount,
                description: this.state.allowanceDeductionDetails.allowanceDeductionDescription,
                unit: this.state.allowanceDeductionDetails.allowanceDeductionUnit
            };
            let allValue = [...this.state.allowanceDeductionQuota, newEntry];
            this.setState({
                allowanceDeductionQuota: allValue,
                allowanceDeductionDetails: {
                    selectedAllowanceDeduction: null,
                    allowanceDeductionAmount: '',
                    allowanceDeductionDescription: '',
                    allowanceDeductionUnit: ''
                }
            });
        }

        // Delete Allowance/Deduction Entry
        // If the row corresponds to an existing record (has an `id`), mark it as inactive
        // so it will be sent to the backend with `isActive: false`. If it's a new/local row,
        // remove it from the array.
        deleteAllowanceDeduction = (removeIndex) => {
            this.setState(prevState => {
                const arr = prevState.allowanceDeductionQuota ? [...prevState.allowanceDeductionQuota] : [];
                const item = arr[removeIndex];
                if (item && (item.id || item.id === 0 || item.id === '0')) {
                    // existing record - mark inactive but keep in list so backend can process deletion
                    arr[removeIndex] = { ...item, isActive: false };
                } else {
                    // new/local record - remove from list
                    arr.splice(removeIndex, 1);
                }
                return { allowanceDeductionQuota: arr };
            });
        }

        // Handle Allowance/Deduction selection (for auto-fill description)
        handleAllowanceDeductionChange = (e) => {
            const selectedValue = e.value;
            
            // Auto-fill description based on selection
            let description = '';
            if (this.props.AllowanceDeduction && this.props.AllowanceDeduction.length > 0) {
                const selected = this.props.AllowanceDeduction.find(item => item.value === selectedValue);
                if (selected) {
                    description = selected.label;
                }
            }
            
            this.setState({ 
                allowanceDeductionDetails: {
                    ...this.state.allowanceDeductionDetails,
                    selectedAllowanceDeduction: selectedValue,
                    allowanceDeductionDescription: description
                }
            });
        }


    componentDidMount(){
        this.props.fetchPositionLists();

        
        this.props.getMasterKeywordList('Allowance'); 

        this.props.getMasterKeywordList('relationType'); 
        this.props.getMasterKeywordList('empgrade/keyword');
        this.props.getMasterKeywordList('personalsubarea/keyword'); 
        this.props.getMasterKeywordList('personalarea/keyword'); 
        this.props.getMasterKeywordList('paytype/keyword'); 
        this.props.getMasterKeywordList('payrollarea/keyword'); 
        this.props.getMasterKeywordList('employeegroup/keyword'); 
        this.props.getMasterKeywordList('employeesubgroup/keyword'); 
        this.props.getMasterKeywordList('agreement/keyword'); 
        this.props.getMasterKeywordList('salarytype/keyword');
        this.props.getMasterKeywordList('saudinonsaudi/keyword');
        this.props.getMasterKeywordList('RELIGION/keyword');
        this.props.getMasterKeywordList('nationality/keyword');
        // this.props.getMasterKeywordList('demobilizestatus/keyword');
        this.props.getMasterKeywordList('EmployeeStatus')
        this.props.getMasterKeywordList('DemoblizeStatus')

        //for salarytype numeric value
        this.props.getMasterKeywordList('salarytypen');
        
        
        
        
        
        //this.props.getMasterKeywordList('costcenterapco'); 
        
        setTimeout(()=>{  this.props.getMasterKeywordList('costcenterapco/keyword'); },1000)
        
        
        
        
        setTimeout(()=>{  this.props.getMasterKeywordList('TimeoffType'); },1000)
        setTimeout(()=>{  this.props.getMasterKeywordList('TicketClass'); },1000)
        setTimeout(()=>{  this.props.getMasterKeywordList('VisaType'); },1000)
        setTimeout(()=>{  this.props.getMasterKeywordList('employeeGroup'); },2000)
        
        // setTimeout(()=>{  this.props.getMasterKeywordList('Division'); },4000)
        setTimeout(()=>{  this.props.getMasterKeywordList('Department'); },1000)
        setTimeout(()=>{  this.props.getMasterKeywordList('project'); },1000) //changed P to p
        setTimeout(()=>{  this.props.getMasterKeywordList('Section'); },5000)
        setTimeout(()=>{  this.props.getMasterKeywordList('UnCategorized'); },6000)
        setTimeout(()=>{  this.props.getMasterKeywordList('VicePresident'); },7000)
        setTimeout(() => { this.props.getMasterKeywordList('Executive'); }, 8000)
        setTimeout(()=>{  this.props.getMasterKeywordList('ShiftPattern'); },1000)
        setTimeout(()=>{  this.props.getMasterKeywordList('Vendor'); },1000)

       

        let type = this.props.match.params.type;
        this.setState({dependentDetails :[],type:type});
        this.setState({poDetails :[],type:type});

        this.getAccess = HASACCESS(EMPLOYEE_SUBMENU_ID);
        if(type !== 'add'){
            this.setState({loading:true});
            setTimeout(()=>{
                this.fetchSingleProcess();
                this.setState({loading:false});
            },3000)
          
        }



    }
  
    fetchSingleProcess = () =>{

        let id = this.props.match.params.id;   
        let type = this.props.match.params.type;
        this.props.getMasterTableList(`GetEmployeeMaster?Employee_id=${id}&Company_Id=${this.state.CompanyId}`); 

    }

    loadProfilePicture = (employeeDetails) => {
        this.setState({loading: true})
        let employeeNumber = employeeDetails.employeeNo || false;
        if (employeeNumber) {
            let extension = 'jpg';
            let fileName = `${employeeNumber}.jpg`;
            let folderName = 'ProfileImage';

            axios({
                url: `/master/api/Download?filename=${fileName}&&FolderName=${folderName}&&ext=${extension}`,
                method: 'GET',
                responseType: 'blob', // important
            }).then((response) => {
                let profilePictureAvailable = response.data.type == 'application/octet-stream' ? true : false
                const profilePicUrl = window.URL.createObjectURL(new Blob([response.data]));
                if(profilePictureAvailable){
                    this.setState({profilePicUrl});
                }                        
                this.setState({loading: false})
            }).catch((err) => {
                this.growl.show({ severity: 'error', summary: 'null', detail: 'Profile picture download failed, please try again' });
            })                
        }
    }

    componentDidUpdate(prevProps, prevState){
          // Handle successful update - reload employee data
 if (this.props.success !== null && prevProps.success !== this.props.success && this.state.type === 'edit') {
    setTimeout(() => {
      this.props.history.push('/employee-master'); // back to Employee Master after successful update
    }, 1000);
    }
            // Only update poDetails when tableLists changes (after fetch)
    if ( this.props.tableLists && this.props.tableLists.employeepo && this.props.tableLists.employeepo !== prevProps.tableLists?.employeepo) {
        const empPo = this.props.tableLists.employeepo.map((po, index) => ({
            rowNo: index + 1,
            employeePoId: po.employeepoid,  // permanent ID from backend
            pono: po.pono,
            headertext: po.headertext,
            itemdesc: po.itemdesc,
            agent: po.agent,
            podate: po.podate ? new Date(po.podate) : null,
            pofrom: po.pofrom ? new Date(po.pofrom) : null,
            poto: po.poto ? new Date(po.poto) : null,
            lineItemReg: po.lineItemReg,
            regprice: po.regprice,
            regunit: po.regunit,
            lineItemOt: po.lineItemOt,
            otprice: po.otprice,
            otunit: po.otunit,
            weeklyWorkingHr: po.weeklyWorkingHr,
            holiday: po.holiday,
            deleted: po.deleted,
            isActive: po.deleted === 0,
        }));
        this.setState({ poDetails: empPo });
    }


        if(this.props.tableLists && this.props.tableLists.employee!==undefined && this.state.loadOnce){
        //    if ( this.props.tableLists !== prevProps.tableLists && this.props.tableLists &&  this.props.tableLists.employee !== undefined  ) { //changed : removed the loadonce logic 
           

            let employee = this.props.tableLists.employee;


            let employeeDependant = this.props.tableLists.employeeDependant;
            let employeePosition = this.props.tableLists.employeePosition;
            let employeeLeaveTypeQuota= this.props.tableLists.employeeLeaveTypeQuota;
            let employeeTicketQuota= this.props.tableLists.employeeTicketQuota;
            let employeeVisaQuota= this.props.tableLists.employeeVisaQuota;
            let employeepo = this.props.tableLists.employeepo;
            let employeedocuments = this.props.tableLists.employeeDocuments;
            let employeeAllowance = this.props.tableLists.employeeAllowance;
           
            let data = {
                ContractorId: employee.contractorId,
                employeeId: employee.employeeId,
                EmployeeNo : employee.employeeNo,
                Employeetypeid : employee.employeetypeid,
                Firstname : employee.firstname,
                Lastname : employee.lastname,
                internalEmail : employee.emailid,
                phoneNo : employee.phone,
                mobileNo : employee.mobileno,
                VendorId : employee.vendorId,
                isActive : employee.isactive,
                createdBy: employee.createdby,
                religion: employee.religion,
               // createdDate : '',
                EmployeeGradeNo : employee.employeeGradeNo,
                nationId : employee.nationId,
                nationality : employee.nationality,
                nationalityArabic : employee.nationalityArabic,
                Gender : employee.gender,
                DateOfJoin : (employee.dateOfJoin!==null) ? new Date(employee.dateOfJoin) : '',
                Middlename : employee.middlename,
                FirstnameAr : employee.firstnameAr,
                MiddlenameAr : employee.middlenameAr,
                LastnameAr : employee.lastnameAr,
                Costcenter : employee.costcenter,
                BupaId : employee.bupaId,
                Iqama : employee.iqama,
                nationID : employee.nationID,
                DateOfBirth : (employee.dateOfBirth!==null) ? new Date(employee.dateOfBirth) : '',
                Confirmationdate : (employee.confirmationdate!==null) ? new Date(employee.confirmationdate) : '',
                hireDate : (employee.hireDate!==null) ? new Date(employee.hireDate) : '',
                terminationDate : (employee.terminationDate!==null) ? new Date(employee.terminationDate) : '',
                Appointmentletterdt: (employee.appointmentletterdt !== null) ? new Date(employee.appointmentletterdt) : '',
                apcocardexpirydate : (employee.apcocardexpirydate!==null) ? new Date(employee.apcocardexpirydate) : '',
                status : employee.empStatus,
                EmpGroupId: employee.empGroupId,
                grade: employee.grade,
                companyId: employee.companyId,
                shiftpatternId:employee.shiftpatternId,
                persarea: employee.persarea,
                perssubarea: employee.perssubarea,
                empgrp: employee.empgrp,
                empsubgrp: employee.empsubgrp,
                // empsubgrp: employee.empsubgrp ? employee.empsubgrp.padStart(2, '0') : '',
                payrollarea: employee.payrollarea,
                workrule: employee.workrule,
                paytype: employee.paytype,
                payarea: employee.payarea,
                paygroup: employee.paygroup,
                paylevel: employee.paylevel,
                project: employee.project,
                vendortimesheetemail: employee.vendortimesheetemail,
                catagory: employee.catagory,
                salarytype: employee.salarytype,
                contractype: employee.contractype,
                cardno: employee.cardno,
                address: employee.address,
                visastatus: employee.visastatus,
                visatype: employee.visatype,
                probationperiod: employee.probationperiod,
                sponsor: employee.sponsor,
                apcocardno: employee.apcocardno,
              //  apcocardexpirydate: employee.apcocardexpirydate,
               // religion: employee.religion,
                hourlyrate: employee.hourlyrate,
                agreement: employee.agreement,
                saudinonsaudi: employee.saudinonsaudi,
                apcomobilenumber: employee.apcomobilenumber,
                campallotted: employee.campallotted,
                seniority: employee.seniority,
                demobilizestatus: employee.demobilizestatus || "0",
                fatherName: employee.bankAljazeeera || '',
                workLocation: employee.bankRiyadh || '',
                noticePeriod: employee.bankSamba || employee.banksamba || '',
                dailyWorkHours: employee.bankEnma || '',
                breakTime: employee.bankNcb || '',
                weeklyOff: (employee.bankFranci !== null && employee.bankFranci !== undefined && employee.bankFranci !== '') ? Number(employee.bankFranci) : null,
                demobilizeremark: employee.demobilizeremark || '',
                demobilizedate: (employee.demobilizedate !== null) ? new Date(employee.demobilizedate) : '',
                loadOnce: false,
                profession: employee.profession,
                positionEn: employee.positionEn,
                
                // Bank Details
                bankName: employee.bankname || '',
                branchName: employee.bankbranchname || '',
                accountHolderName: employee.bankaccountname || '',
                accountNumber: employee.bankAccNo || '',
                ifscCode: employee.ifsccode || '',
                ibannumber: employee.ibannumber || '',
                upiId: employee.upiid || '',

                // Statutory & Compliance Details
                panNumber: employee.pannumber || '',
                aadhaarNumber: employee.aadhaarnumber || '',
                uanNumber: employee.uannumber || '',
                pfNumber: employee.pfnumber || '',
                esiNumber: employee.esinumber || '',
                ptState: employee.professionaltaxstate || '',
                tanLocation: employee.tanlocation || '',
                form12bSubmitted: employee.form12bsubmitted || '',
                prevEmpIncome: employee.previousemployerincome || '',
                prevEmpTax: employee.previousemployertax || '',
                gratuityNumber: employee.gratuitynumber || '',

                // Deduction Percentages
                pfPercentage: employee.pf || '',
                esiPercentage: employee.esi || '',
                ptPercentage: employee.pt || '',
                tdsPercentage: employee.tds || ''
            }

            this.loadProfilePicture(employee)

            let empDependent = [];
            if(employeeDependant && employeeDependant.length > 0){
                empDependent = employeeDependant.map((dept,index) => {

                    let gender = "1";
                    if(parseInt(dept.gender) === 2 ){
                        gender = "2";
                    }
                    return { id : index+1, name: dept.name,
                            relation: parseInt(dept.relationType),
                            age: parseInt(dept.age),
                            gender: gender,
                            location: ''}
                })

                data.dependentDetails = empDependent;
            }
            
            let empPo = [];
            if(employeepo && employeepo.length > 0){
                empPo = employeepo.map((po,index) => {

                    return {
                        rowNo: index + 1,
                        employeePoId: po.employeepoid,  //new
                        pono: po.pono,
                        headertext: po.headertext,
                        itemdesc: po.itemdesc,
                        agent: po.agent,
                        podate: po.podate ? new Date(po.podate) : null,
                        pofrom: po.pofrom ? new Date(po.pofrom) : null,
                        poto: po.poto ? new Date(po.poto) : null,
                        lineItemReg: po.lineItemReg,
                        regprice: po.regprice,
                        regunit: po.regunit,
                        lineItemOt: po.lineItemOt,
                        otprice: po.otprice,
                        otunit: po.otunit,
                        weeklyWorkingHr: po.weeklyWorkingHr,
                        holiday: po.holiday,
                        deleted: po.deleted,
                        isActive: po.deleted === 0,

                    }
                })

                data.poDetails = empPo;
            }

            let empdoc = [];
            if(employeedocuments && employeedocuments.length > 0){
                empdoc = employeedocuments.map((doc,index) => {

                    return {  
                        EmployeeDocumentId: doc.employeeDocumentId ?? null,
                        EmployeeId: doc.employeeId,
                        DocType: doc.docType,
                        DocDocumentType: doc.docDocumentType,
                        DocDocumentNo: doc.docDocumentNo,
                        DocIssuPlace: doc.docIssuPlace,
                        DocIssuDate: doc.docIssuDate,
                        DocExpiryDate: doc.docExpiryDate,
                        Createdby: doc.createdby,
                        Createddate: doc.createddate,
                        Updatedby: doc.updatedby,
                        Updateddate: doc.updateddate,
                        CompanyId: doc.companyId,
                        Expiryarabic: doc.expiryarabic,
                        // Reconstruct Attachment object from API response fields
                        Attachment: (doc.fileName || doc.uploadPath) ? {
                            fileExtension: doc.extension || '',
                            filePath: doc.uploadPath || '',
                            fileName: doc.fileName || '',
                            virtualFilePath: doc.uploadPath || '',
                            folderName: 'EmployeeDocument'
                        } : null,
                    }
                })

                data.depTypes = empdoc;
            }

            // Allowance & Deduction - map fetched values into state format
            let empAllowance = [];
            if(employeeAllowance && employeeAllowance.length > 0){
                empAllowance = employeeAllowance.map((al, index) => {
                    return {
                        id: al.id ?? null,  
                        allowanceType: al.alowanceAndDeductId || '',
                        amount: al.allowance || al.deduction || '',
                        description: al.description || '',
                        unit: al.unit || null,
                        isActive: al.isActive !== undefined ? al.isActive : null  // default to true if not provided
                    }
                });

                data.allowanceDeductionQuota = empAllowance;
            }

            let empLeaveQuota = [];
            let empQuota = [];
            if(employeeLeaveTypeQuota && employeeLeaveTypeQuota.length > 0){
                empQuota = employeeLeaveTypeQuota.map((quota,index) => {
                    return {
                        id: index,
                        Year: quota.year,
                        leaveQuotaId: quota.leaveQuotaId,
                        employeeId: quota.employeeId,
                        employeeNo: quota.employeeNo,
                        Id: quota.Id,
                        leaveType: quota.timeOffTypeId,
                        allocated : quota.allocatedDays,
                        used: quota.usedDays,
                        balance: quota.balanceDays,
                       }
                })

                data.leaveQuota = empQuota;//  empLeaveQuota;
            }

            let empTicketQuota = [];
            let empTQuota = [];
            if(employeeTicketQuota && employeeTicketQuota.length > 0){
                empTQuota = employeeTicketQuota.map((Tquota,index) => {
                    return {
                        id : index,
                        TicketType: Tquota.ticketQuotaId,
                        Year : Tquota.year,
                        allocated : Tquota.allocatedQuota,
                        usedQuota: Tquota.usedQuota,
                        balanceQuota: Tquota.balanceQuota,
                       }
                })

                data.TicketQuota = empTicketQuota;
            }
            
            let empVisaQuota = [];
            let empVQuota = [];
            if(employeeVisaQuota && employeeVisaQuota.length > 0){
                empVQuota = employeeVisaQuota.map((Vquota,index) => {
                    return {
                        id : index,
                        visaType: Vquota.visaQuotaId,
                        Year : Vquota.year,
                        allocated : Vquota.allocatedQuota,
                        usedQuota: Vquota.usedQuota,
                        balanceQuota: Vquota.balanceQuota,
                       }
                })

                data.VisaQuota = empVisaQuota;
            }
            if (employeePosition && employeePosition.length > 0) {
                data.selectedPosition = employeePosition[0].positionId;
                data.employeePostionId = employeePosition[0].employeePostionId;
                data.employeeId = employeePosition[0].employeeId;
                data.executives = employeePosition[0].executiveUnitId;
                data.isExecutive = employeePosition[0].isExecutiveUnit;
                data.selectedVicePresident = employeePosition[0].vpUnitId ;
                data.isPresident = employeePosition[0].isVpUnit;
                data.selectedDivision = employeePosition[0].divisionId;
                data.isDivision = employeePosition[0].isDivision;
                data.selectedDepartment = employeePosition[0].departmentId;
                data.isDepartment = employeePosition[0].isDepartment;
                data.selectedSection = employeePosition[0].sectionId;
                data.isSection = employeePosition[0].isSection;
                data.selectedUNC = employeePosition[0].uncId;
                data.isUnc  = employeePosition[0].isUnc;
            }

            this.setState(data);
        }
    }

    uploadProfilePicture = (e) => {
        e.preventDefault();
        this.setState({ loading: true });
        let file = e.target.files[0];
        if(!file){
            this.setState({loading:false});
            return;
        } 
        let name = this.state.EmployeeNo + '.jpg';
        var extension = file.type
        const frmData = new FormData();
        frmData.append('file', file, name);
        if(!(extension == 'image/jpeg' || extension == 'image/jpg')){
            this.growl.show({ severity: 'error', summary: 'Image type error', detail: `Please upload Image of '.jpg' type` });
            this.setState({ loading: false});
            return;
        }
        
      
        axios.post(`/master/api/upload?FolderName=${'ProfileImage'}`, frmData) 
        .then(response => {
            if(response.status == 200){
                setTimeout(()=>{
                    window.location.reload(false);
                    this.setState({loading:false});
                    this.growl.show({ severity: 'success', summary: null, detail: 'Profile Picture updated successfully'});
                },1000)
            }

        }).catch(err => {
            this.growl.show({ severity: 'error', summary: null, detail: 'Profile Picture update Failed' });
            this.setState({ loading: false });
        })
        
    }
  

    updateDependent = (e, index) => {
        e.preventDefault();
        const { name, value } = e.target;
        const newDeptValue = [...this.state.dependentDetails];
        newDeptValue[index][name] = value;
        this.setState({dependentDetails:newDeptValue})
    }  
    
    //changed updatePo to updatepo
    // updatepo = (e, index) => {  
    //     e.preventDefault();
    //     const { name, value } = e.target;
    //     const newDeptValue = [...this.state.poDetails];
    //     newDeptValue[index][name] = value;
    //     this.setState({poDetails:newDeptValue})
    // } 

    updatepo = (e, id) => {
  const { name, value } = e.target;
  const newPoDetails = this.state.poDetails.map(po =>
    po.employeePoId === id ? { ...po, [name]: value } : po
  );
  this.setState({ poDetails: newPoDetails });
}
    addDept = (e) => {
        e.preventDefault();
        let newDept = {
            id: this.state.dependentDetails.length + 1,
            name: '',
            relation: '',
            age: '',
            gender: '',
            location: ''
        }
        let dptValue = [...this.state.dependentDetails, newDept];
        this.setState({dependentDetails:dptValue})
    }

    addPo = (e) => {
        let tempId = 'temp-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
        e.preventDefault();
        let newPo = {
            rowNo: this.state.poDetails.length + 1, // Next sequence number
            employeePoId: tempId, // Assign a unique temporary ID
            pono: '',
            headertext: '',
            itemdesc: '',
            agent: '',
            podate: null,
            pofrom: null,
            poto: null,
            lineItemReg: '',
            regprice: '',
            regunit: '',
            lineItemOt: '',
            otprice: '',
            otunit: '',
            weeklyWorkingHr: '',
            holiday: [],
            isActive: true ,
            deleted: 0,
        }
        let poValue = [...this.state.poDetails, newPo];
        this.setState({poDetails:poValue})

//         this.setState(prevState => ({
//   poDetails: [...prevState.poDetails, newPo]
// }));
    }


    removeDept = (index) => {
        const updatedDeptValue = this.state.dependentDetails.filter( (value,ind) => {
           
            return ind !== parseInt(index);
        });
        this.setState({dependentDetails:updatedDeptValue})
 
    }


    //new for deletePO by id
        removePo = (id) => {
        if (id && id.startsWith('temp-')) {
        const updatedPoValue = this.state.poDetails.filter(po => po.employeePoId !== id);
        this.setState({ poDetails: updatedPoValue });
        } else { this.growl.show({ severity: 'warn', summary: 'Delete Not Allowed', detail: 'You cannot delete a PO entry that is already saved.'
            });
        }
        }

    deleteLeave  = (removeIndex) => {

        const updatedDeptValue = this.state.leaveQuota.filter((value,index) => {
            return removeIndex !== index;
        })
        this.setState({leaveQuota:updatedDeptValue})

    }

    deleteTicket  = (removeIndex) => {

        const updatedDeptValue = this.state.TicketQuota.filter((value,index) => {
            return removeIndex !== index;
        })
        this.setState({TicketQuota:updatedDeptValue})

    }
    
    deleteVisa  = (removeIndex) => {

        const updatedDeptValue = this.state.VisaQuota.filter((value,index) => {
            return removeIndex !== index;
        })
        this.setState({VisaQuota:updatedDeptValue})

    }

    addLeaveQuota = () => {

        let newDoc = {leaveType : this.state.leaveType,Year:this.state.YearL, used:this.state.used,balance:this.state.balance,allocated:this.state.allocated};
        let docValue = [...this.state.leaveQuota, newDoc];
        this.setState({leaveQuota:docValue,used:'',balance:'',allocated:''})
    }

    addTicketQuota = () => {

        let newDoc = {TicketType : this.state.TicketType, usedQuota:this.state.usedt,balanceQuota:this.state.balancet,allocated:this.state.allocatedt,year:this.state.Yeart};
        let docValue = [...this.state.TicketQuota, newDoc];
        this.setState({TicketQuota:docValue,usedt:'',balancet:'',allocatedt:'',Yeart:''})
    }

    addVisaQuota = () => {

        let newDoc = {visaType : this.state.visaType, usedQuota:this.state.usedV,balanceQuota:this.state.balanceV,allocated:this.state.allocatedV,Year:this.state.YearV};
        let docValue = [...this.state.VisaQuota, newDoc];
        this.setState({VisaQuota:docValue,usedV:'',balanceV:'',allocatedV:'',YearV:''})
    }
    
    // let EmployeeData = {
    //     ContractorId : this.state.ContractorId,
    //     EmployeeId : this.state.employeeId,
    //     EmployeeNo : this.state.EmployeeNo,
    //     Employeetypeid : this.state.Employeetypeid,
    //     Firstname : this.state.Firstname,
    //     Lastname : this.state.Lastname,
    //     Emailid : this.state.internalEmail,
    //     Phone : this.state.phoneNo,
    //     Mobileno : this.state.mobileNo,
    //     VendorId : this.state.VendorId,
    //     Isactive : this.state.isActive,
    //     Createdby : this.state.createdBy,
    //     Createddate : this.state.createdDate,
    //     Updatedby : null,
    //     Updateddate : null,
    //     OrgUnit : null,
    //     OrgType : null,
    //     OrgName : null,
    //     OrgUnitc : null,
    //     OrgNamec : null,
    //     MobileId : null,
    //     ArabicName : null,
    //     SecurityQues : null,
    //     SecurityAns : null,
    //     EmployeeGradeNo : this.state.EmployeeGradeNo,
    //     NationId : this.state.NationId,
    //     Nationality : this.state.nationality,
    //     NationalityArabic : this.state.nationalityArabic,
    //     Gender : this.state.Gender,
    //     GenderArabic : null,
    //     DateOfJoin : null,// this.state.DateOfJoin.toISOString().split("T")[0],
    //     Id1 : null,
    //     SalaryBasic : null,
    //     SalaryTransport : null,
    //     SalaryHousing : null,
    //     BankSamba : null,
    //     BankEnma : null,
    //     BankAljazeeera : null,
    //     BankSaudiInvestment : null,
    //     BankSaudiHollandi : null,
    //     BankRiyadh : null,
    //     BankFranci : null,
    //     BankBritish : null,
    //     BankNcb : null,
    //     Department : null,
    //     Middlename : this.state.Middlename,
    //     FirstnameAr : this.state.FirstnameAr,
    //     MiddlenameAr : this.state.MiddlenameAr,
    //     LastnameAr : this.state.LastnameAr,
    //     Sapid : null,
    //     Costcenter : this.state.Costcenter,
    //     AnnualVacationDays : null,
    //     SalaryBonus : null,
    //     EnglishName : null,
    //     PositionEn : null,
    //     DepartmentEn : null,
    //     BupaId : this.state.BupaId,
    //     Name : null,
    //     CostcenterAr : null,
    //     CostcenterId : null,
    //     Qualification : null,
    //     Specialization : null,
    //     PositionAr : null,
    //     Grade : null,
    //     DepartmentAr : null,
    //     TotalSalary : null,
    //     Ticket : null,
    //     Exitreentry : null,
    //     Iqama : this.state.Iqama,
    //     BankNameAr : null,
    //     BankAccNo : null,
    //     Recruitment : null,
    //     City : null,
    //     Speciality : null,
    //     Nation : this.state.nationID,
    //     CompanyId : null,
    //     DateOfBirth : this.state.DateOfBirth,
    //     Confirmationdate : this.state.Confirmationdate,
    //     HireDate : this.state.hireDate,
    //     TerminationDate : this.state.terminationDate,
    //     Appointmentletterdt : this.state.Appointmentletterdt,
    //     EmpStatus : this.state.status,
    //     PafrecordId : null,
    //     EmpGroupId : this.state.EmpGroupId,
    
    // } 

    add = () => {
        const { employeeId } = this.state;
        console.log('Allowance Quota Data:', JSON.stringify(this.state.allowanceDeductionQuota, null, 2));
        
        // Extract salary/allowance amounts from allowanceDeductionQuota by exact allowanceType ID
        let SalaryBasic = null;
        let SalaryTransport = null;
        let SalaryHousing = null;
        
        if (this.state.allowanceDeductionQuota && this.state.allowanceDeductionQuota.length > 0) {
            // Match by exact allowanceType UUID
            const basicEntry = this.state.allowanceDeductionQuota.find(a => a.allowanceType === "74c3883f-8a95-4d43-9bc6-2907e2568158");
            const housingEntry = this.state.allowanceDeductionQuota.find(a => a.allowanceType === "a50e5633-6ab1-4f2e-866f-a8cc7a9c7218");
            const transportEntry = this.state.allowanceDeductionQuota.find(a => a.allowanceType === "a50e5633-6ab1-4f2e-866f-a8cc7a9c7219");
            
            SalaryBasic = basicEntry ? parseFloat(basicEntry.amount) : null;
            SalaryHousing = housingEntry ? parseFloat(housingEntry.amount) : null;
            SalaryTransport = transportEntry ? parseFloat(transportEntry.amount) : null;
        }
        
        let EmployeeData = {
            ContractorId: this.state.ContractorId,
            EmployeeId: this.state.employeeId != '' && this.state.employeeId != undefined? this.state.employeeId : '00000000-0000-0000-0000-000000000000',
            EmployeeNo : this.state.EmployeeNo,
            Employeetypeid : this.state.Employeetypeid,
            Firstname : this.state.Firstname,
            Lastname : this.state.Lastname,
            Emailid : this.state.internalEmail,
            Phone : this.state.phoneNo,
            Mobileno : this.state.mobileNo,
            VendorId : this.state.VendorId,
            Isactive : this.state.isActive,
            Createdby : this.state.createdBy,
            Createddate: this.state.createdDate,
            Updatedby :this.props.loggedUserDetail.empID ,
            Updateddate : moment().format('MM/DD/YYYY') ,
            OrgUnit : null,
            OrgType : null,
            OrgName : null,
            OrgUnitc : null,
            OrgNamec : null,
            MobileId : null,
            ArabicName : null,
            SecurityQues : null,
            SecurityAns : null,
            EmployeeGradeNo : this.state.EmployeeGradeNo,
            NationId : this.state.nationId,
            Nationality : this.state.nationality,
            NationalityArabic : this.state.nationalityArabic,
            Gender : this.state.Gender,
            GenderArabic : null,
            DateOfJoin: this.state.DateOfJoin ? moment(this.state.DateOfJoin).format('MM/DD/YYYY') : null,
            // DateOfJoin : null,// this.state.DateOfJoin.toISOString().split("T")[0],
            Id1 : null,
            salaryBasic : SalaryBasic,
            SalaryTransport : SalaryTransport,
            SalaryHousing : SalaryHousing,
            // Restaurant Related Details
            BankSamba : this.state.noticePeriod,
            BankEnma : this.state.dailyWorkHours,
            BankAljazeeera : this.state.fatherName,
            BankSaudiInvestment : null,
            BankSaudiHollandi : null,
            BankRiyadh : this.state.workLocation,
            BankFranci : (this.state.weeklyOff !== null && this.state.weeklyOff !== undefined) ? String(this.state.weeklyOff) : null,
            BankBritish : null,
            BankNcb : this.state.breakTime,
            Department : null,
            Middlename : this.state.Middlename,
            FirstnameAr : this.state.FirstnameAr,
            MiddlenameAr : this.state.MiddlenameAr,
            LastnameAr : this.state.LastnameAr,
            Sapid : null,
            Costcenter : this.state.Costcenter,
            AnnualVacationDays : null,
            SalaryBonus : null,
            EnglishName : null,
            PositionEn : this.state.positionEn,
            DepartmentEn : null,
            BupaId : this.state.BupaId,
            Name : null,
            CostcenterAr : null,
            CostcenterId : null,
            Qualification : null,
            Specialization : null,
            PositionAr: null,
           // PositionEn: this.state.positionEn,
            //Grade : null,
            DepartmentAr : null,
            TotalSalary : null,
            Ticket : null,
            Exitreentry : null,
            Iqama : this.state.Iqama,
            BankNameAr : null,
            BankAccNo : null,
            Recruitment : null,
            City : null,
            Speciality : null,
            //Nation : this.state.nationID,
            DateOfBirth: this.state.DateOfBirth ? moment(this.state.DateOfBirth).format('MM/DD/YYYY') : null,
            Confirmationdate: this.state.Confirmationdate ? moment(this.state.Confirmationdate).format('MM/DD/YYYY') : null,
            HireDate : this.state.hireDate,
            terminationDate: this.state.terminationDate ? moment(this.state.terminationDate).format('MM/DD/YYYY') : null,
            Appointmentletterdt: this.state.Appointmentletterdt ? moment(this.state.Appointmentletterdt).format('MM/DD/YYYY') : null,
            apcocardexpirydate: this.state.apcocardexpirydate ? moment(this.state.apcocardexpirydate).format('MM/DD/YYYY') : null,

            EmpStatus : this.state.status,
            PafrecordId : null,
            EmpGroupId: this.state.EmpGroupId,
            Grade: this.state.grade,
            CompanyId: '414FE8CA-61AA-4876-8FA5-22940150212E',
            ShiftpatternId: this.state.shiftpatternId,
            Persarea: this.state.persarea,
            Perssubarea: this.state.perssubarea,
            Empgrp: this.state.empgrp,
            Empsubgrp: this.state.empsubgrp,
            Payrollarea: this.state.payrollarea,
            Workrule: this.state.workrule,
            Paytype: this.state.paytype,
            Payarea: this.state.payarea,
            Paygroup: this.state.paygroup,
            Paylevel: this.state.paylevel,
            Project: this.state.project,
            Vendortimesheetemail: this.state.vendortimesheetemail,
            Profession: this.state.profession,
            Catagory: this.state.catagory,
            Salarytype: this.state.salarytype,
            Contractype: this.state.contractype,
            Cardno: this.state.cardno,
            Address: this.state.address,
            Visastatus: this.state.visastatus,
            Visatype: this.state.visatype,
            Probationperiod: this.state.probationperiod,
            Sponsor: this.state.sponsor,
            Apcocardno: this.state.apcocardno,
            // Apcocardexpirydate: this.state.apcocardexpirydate,
            Religion: this.state.religion,
            Hourlyrate: this.state.hourlyrate,
            Agreement: this.state.agreement,
            Agreementexpirydate: this.state.agreementexpirydate,
            Saudinonsaudi:this.state.saudinonsaudi,
            Apcomobilenumber: this.state.apcomobilenumber,
            Campallotted: this.state.campallotted,
            Seniority: this.state.seniority,
            Demobilizestatus: this.state.demobilizestatus,

            // Bank Details
            bankname: this.state.bankName,
            bankbranchname: this.state.branchName,
            bankaccountname: this.state.accountHolderName,
            bankAccNo: this.state.accountNumber,
            ifsccode: this.state.ifscCode,
            ibannumber: this.state.ibannumber || '',
            upiid: this.state.upiId,

            // Statutory & Compliance Details
            pannumber: this.state.panNumber,
            aadhaarnumber: this.state.aadhaarNumber,
            uannumber: this.state.uanNumber,
            pfnumber: this.state.pfNumber,
            esinumber: this.state.esiNumber,
            professionaltaxstate: this.state.ptState,
            tanlocation: this.state.tanLocation,
            form12bsubmitted: this.state.form12bSubmitted,
            previousemployerincome: this.state.prevEmpIncome,
            previousemployertax: this.state.prevEmpTax,
            gratuitynumber: this.state.gratuityNumber,

            // Deduction Percentages
            pf: this.state.pfPercentage,
            esi: this.state.esiPercentage,
            pt: this.state.ptPercentage,
            tds: this.state.tdsPercentage
        
        }
        let EmployeePositionData = [{
            PositionId: this.state.selectedPosition,
            EmployeePostionId: this.state.employeePostionId != '' && this.state.employeePostionId != undefined? this.state.employeePostionId : '00000000-0000-0000-0000-000000000000',          
            EmployeeId: this.state.employeeId != '' && this.state.employeeId != undefined? this.state.employeeId : '00000000-0000-0000-0000-000000000000',          
                UncId : this.state.selectedUNC, 
                IsUnc : this.state.isUnc,
                SectionId : this.state.selectedSection,
                IsSection : this.state.isSection,
                DepartmentId : this.state.selectedDepartment,
                IsDepartment : this.state.isDepartment,
                DivisionId : this.state.selectedDivision,
                IsDivision : this.state.isDivision,
                VpUnitId : this.state.selectedVicePresident,
                IsVpUnit : this.state.isPresident,
                ExecutiveUnitId : this.state.selectedExecutive,
                IsExecutiveUnit : this.state.isExecutive,
                EmployeeLevelId : null,
                Isactive : true,      //not needed as advised by Mr. Aboobacker
                Createdby : this.state.createdBy,
                Createddate : this.state.createdDate,
                Updatedby : null,
                Updateddate : null,
                CompanyId : '414FE8CA-61AA-4876-8FA5-22940150212E'
        }]


            let EmployeeDocumentsData = this.state.depTypes.map(list => {
            return {
                // include employeeDocumentId only when it exists (not for new records)
                ...(list.EmployeeDocumentId !== null && list.EmployeeDocumentId !== undefined && list.EmployeeDocumentId !== '' ? { employeeDocumentId: list.EmployeeDocumentId } : {}),
                employeeId: this.state.employeeId != '' && this.state.employeeId != undefined? this.state.employeeId : '00000000-0000-0000-0000-000000000000',          

                docType: list.DocType,
                docDocumentType: list.DocDocumentType,
                docDocumentName: null,
                docDocumentNo: list.DocDocumentNo,
                docIssuPlace: list.DocIssuPlace,
                docIssuDate: list.DocIssuDate ? (moment(list.DocIssuDate, 'DD/MM/YYYY', true).isValid() ? moment(list.DocIssuDate, 'DD/MM/YYYY').toISOString() : (moment(list.DocIssuDate).isValid() ? moment(list.DocIssuDate).toISOString() : null)) : null,
                docExpiryDate: list.DocExpiryDate ? (moment(list.DocExpiryDate, 'DD/MM/YYYY', true).isValid() ? moment(list.DocExpiryDate, 'DD/MM/YYYY').toISOString() : (moment(list.DocExpiryDate).isValid() ? moment(list.DocExpiryDate).toISOString() : null)) : null,
                createdby: list.Createdby,
                createddate: list.Createddate,
                updatedby: list.Updatedby,
                updateddate: list.Updateddate,
                companyId: '414FE8CA-61AA-4876-8FA5-22940150212E',
                isActive: null,
                expiryarabic: list.Expiryarabic,
                fileName: list.Attachment ? list.Attachment.fileName : null,
                extension: list.Attachment ? list.Attachment.fileExtension : null,
                status: null,
                uploadPath: list.Attachment ? (list.Attachment.virtualFilePath || list.Attachment.filePath) : null
            }
        } ) 

  

        let EmployeeDependentData = this.state.dependentDetails.map(detail => {
            return{
                dependantid: detail.dependantid || '00000000-0000-0000-0000-000000000000', // <-- Add this line
                RelationType : detail.relation,
                Name : detail.name,
                NameAr : detail.name,
                Age : detail.age,
                Gender : detail.gender,
                Nationality : detail.location
            }
        } )
        
        let EmployeePoData = this.state.poDetails.map(detail => {
            return{
                // RelationType : detail.relation,
                // Name : detail.name,
                // NameAr : detail.name,
                // Age : detail.age,
                // Gender : detail.gender,
                // Location : detail.location,

                //new for po payload
                EmployeePoId: detail.employeePoId.startsWith('temp-') ? '00000000-0000-0000-0000-000000000000' : detail.employeePoId,
                EmployeeId: this.state.employeeId != '' && this.state.employeeId != undefined? this.state.employeeId : '00000000-0000-0000-0000-000000000000',
                rowNo: detail.rowNo || detail.rowno || null,
                Pono: detail.pono || '',
                Headertext: detail.headertext || '',
                Itemdesc: detail.itemdesc || '',
                Agent: detail.agent || '',
                Podate: detail.podate ? moment(detail.podate).format('MM/DD/YYYY') : null,
                Pofrom: detail.pofrom ? moment(detail.pofrom).format('MM/DD/YYYY') : null,
                Poto: detail.poto ? moment(detail.poto).format('MM/DD/YYYY') : null,
                Regprice: detail.regprice ? parseFloat(detail.regprice) : null,
                LineItemReg: detail.lineItemReg,
                Regunit: detail.regunit,
                Otprice: detail.otprice,
                LineItemOt: detail.lineItemOt,
                Otunit: detail.otunit,
                Holiday: Array.isArray(detail.holiday) ? detail.holiday.join(',') : detail.holiday,
                WeeklyWorkingHr: detail.weeklyWorkingHr,
                deleted: detail.deleted,
                isActive: detail.isActive,
            }
        } )


        let EmployeeLeaveTypeQuotaData = this.state.leaveQuota.map(detail => {
            return{
                TimeoffPolicyId: null,
                // leaveQuotaId: detail.leaveQuotaId,
                // employeeId: detail.employeeId,
                leaveQuotaId: detail.leaveQuotaId != '' && detail.leaveQuotaId != undefined? detail.leaveQuotaId : '00000000-0000-0000-0000-000000000000',          
                EmployeeId: detail.employeeId != '' && detail.employeeId != undefined? detail.employeeId : '00000000-0000-0000-0000-000000000000',          
                employeeNo: this.state.EmployeeNo,
                //Id: detail.Id,
                TimeOffTypeId : detail.leaveType,
                AllocatedDays: detail.allocated,
                Year: detail.Year,
                UsedDays : detail.used,
                BalanceDays : detail.balance,
                CreatedBy : this.state.createdBy,
                CreatedDate : this.state.createdDate,
                UpdatedBy : null,
                UpdatedDate : null,
                EmployeeNo : this.state.EmployeeNo,
                PresentAbsent : null,
                IsActive : null
                }
        } ) 

        let EmployeeTicketQuotaData = this.state.TicketQuota.map(detail => {
            return{
                TimeoffPolicyId : null,
                TicketTypeId: detail.TicketType,
                Year : detail.year,
                AllocatedQuota : detail.allocated,
                UsedQuota : detail.usedQuota,
                BalanceQuota : detail.balanceQuota,
                CreatedBy : this.state.createdBy,
                CreatedDate: this.state.createdDate,
                Fromdate : this.state.createdDate,
                UpdatedBy : null,
                UpdatedDate : null,
                EmployeeNo : this.state.EmployeeNo,
                PresentAbsent : null,
                IsActive : null
                }
        } )
        
        let EmployeeVisaQuotaData = this.state.VisaQuota.map(detail => {
            return{
                TimeoffPolicyId : null,
                visaTypeId: detail.visaType,
                Year : detail.year,
                AllocatedQuota : detail.allocated,
                UsedQuota : detail.usedQuota,
                BalanceQuota : detail.balanceQuota,
                CreatedBy : this.state.createdBy,
                CreatedDate : this.state.createdDate,
                UpdatedBy: null,
                Fromdate : this.state.createdDate,
                UpdatedDate : null,
                EmployeeNo : this.state.EmployeeNo,
                PresentAbsent : null,
                IsActive : null
                }
        } )

        let EmployeeAllowanceDeductionData = this.state.allowanceDeductionQuota.map(detail => {
            const type = detail.allowanceType === "a50e5633-6ab1-4f2e-866f-a8cc7a9c7221"? 2 : 1;
            const Amount = detail.amount ? parseFloat(detail.amount) : 0;
        return {
            ...(detail.id !== null && detail.id !== undefined && detail.id !== '' ? { id: detail.id } : {}),
            alowanceAndDeductId : detail.allowanceType,
            employeeId: this.state.employeeId != '' && this.state.employeeId != undefined ? this.state.employeeId : '00000000-0000-0000-0000-000000000000',
            employeeNo: this.state.EmployeeNo,
            type: detail.allowanceType === "a50e5633-6ab1-4f2e-866f-a8cc7a9c7221"? 2 : 1,
            AllowanceDeductionType: detail.allowanceType,
            // Amount: detail.amount ? parseFloat(detail.amount) : 0,
            unit: detail.unit || null,
            allowance :type === 1 ? Amount : null,
            deduction :type === 2 ? Amount : null,
            
            description: detail.description,
            createdBy: this.state.createdBy,
            createdDate: this.state.createdDate,
            UpdatedBy: null,
            UpdatedDate: null,
            EmployeeNo: this.state.EmployeeNo,
            isActive: (typeof detail.isActive !== 'undefined') ? detail.isActive : true,
            CompanyId: '414FE8CA-61AA-4876-8FA5-22940150212E',
            
            
        }
    })


        let finalData  = {
            Employee : EmployeeData,
            EmployeePosition : EmployeePositionData,
            EmployeeDocuments : EmployeeDocumentsData,
            EmployeeDependant : EmployeeDependentData,
            EmployeePo : EmployeePoData,
            EmployeeLeaveTypeQuota : EmployeeLeaveTypeQuotaData,
            EmployeeTicketQuota : EmployeeTicketQuotaData,
            EmployeeVisaQuota : EmployeeVisaQuotaData,
            EmployeeAllowance : EmployeeAllowanceDeductionData
        }



        this.props.processDynamicData('Employee',this.state.type,finalData,'GetEmployeeList');

    }

    leaveRender = (rowData) => {
        
        let leaveType = rowData.leaveType;
        let leaveName = '';

        if(this.props.TimeoffType && this.props.TimeoffType.length > 0){
            leaveName = this.props.TimeoffType.filter((type)=>{
                return type.value === leaveType
            }).reduce((result, el) => {
                return el.label;
            },'');
        }
        return leaveName;
    }

    TicketRender = (rowData) => {
        
        let TicketType = rowData.TicketType;
        let TicketName = '';
        
        if(this.props.TicketClass && this.props.TicketClass.length > 0){
            TicketName = this.props.TicketClass.filter((type)=>{
                return type.value === TicketType
            }).reduce((result, el) => {
                return el.label;
            },'');
        }
        return TicketName;
    }
    
    VisaRender = (rowData) => {
        
        let visaType = rowData.visaType;
        let VisaName = '';

        if(this.props.VisaType && this.props.VisaType.length > 0){
            VisaName = this.props.VisaType.filter((type)=>{
                return type.value === visaType
            }).reduce((result, el) => {
                return el.label;
            },'');
        }
        return VisaName;
    }


    render() {   

        let positionList = [];
        if(this.props.positionList && this.props.positionList.length > 0){
            positionList = this.props.positionList;
        }

        let addAccess = true;
        let editAccess = true;
        if(this.getAccess!==undefined){
            if(this.getAccess.viewAccess === false){this.props.history.push('/dashboard')}
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess : addAccess, editAccess : editAccess}
        
        let grid;
        let isLeaveEnabled = (this.state.leaveType!== null) && (this.state.used !== "") && (this.state.balance !== "") 
        let firstGrid = (                            
            <div className="p-grid mt1">
                    <div className="p-col-12 p-lg-3">
                        <div className="card card-w-title ">                          
                        <img src={this.state.profilePicUrl ? this.state.profilePicUrl : "https://rctest-trials65101.orangehrmlive.com/webres_5e746850dfd569.95071480/orangehrmRecruitmentPlugin/images/pro-pic.png"} 
                        alt="" className="image-row-style circle responsive-img" 
                        style={{backgroundColor: "rgb(167, 157, 162)",width: '100%'}}/>
                            {this.state.type == 'edit' && 
                            <div className="p-col-12 " style={{backgroundColor:'#406882', borderRadius:'4px'}}>
                                <label style={{color:'white',fontSize: '15px', width:'100%'}}>{/*style={{width:'100%'}} */}
                                <input type="file" className="inputfile"  name="file" id="file-7" onChange={(e) => this.uploadProfilePicture(e)} />
                                    <strong><img src={UploadImage} alt="upload im" /> Choose a Picture ( .Jpg )&hellip;</strong>
                                </label>
                            </div>
                            }
                        </div>
                    </div>
                    <div className="p-col-12 p-lg-9">
                    <div className="card card-w-title">
                        <h1>Key Data</h1>    
                    <div className="p-grid">
                        <div className="p-col-12 p-md-6 p-lg-4">
                            <label className="label">Employee Type <span className="requiredColor">*</span></label>
                                <div className="mt1"> <Dropdown className="p-col-12" options={this.state.employeeType} value={this.state.Employeetypeid} 
                                    onChange={this.handleChange} placeholder="Select Employee Type" name="Employeetypeid" {...DROPDOWN_CONFIG}/></div>
                        </div>
                     
                        {this.state.Employeetypeid === 2 && (
                        // <div className="p-col-12 p-md-6 p-lg-4">
                        //     <label className="labeltop" htmlFor="textarea">Vendor ID <span className="requiredColor">*</span></label>
                        //     <div className="mt1">
                        //         <InputText className="p-col-12" name="VendorId" onChange={this.handleChange} value={this.state.VendorId} placeholder="Vendor ID"/>
                        //     </div>
                        //         </div>
                        <div className="p-col-12 p-md-6 p-lg-4">
                        <label className="label">Vendor <span className="requiredColor">*</span></label>
                            <div className="mt1"> <Dropdown className="p-col-12" options={this.props.Vendor} value={this.state.VendorId} 
                                onChange={this.handleChange} placeholder="Select Vendor" name="VendorId" {...DROPDOWN_CONFIG}/></div>
                        </div> 
                          )}

                        <div className="p-col-12 p-md-6 p-lg-4">
                            <label className="labeltop" htmlFor="textarea">Employee Number <span className="requiredColor">*</span></label>
                            <div className="mt1">
                                <InputText className="p-col-12" name="EmployeeNo" onChange={this.handleChange} value={this.state.EmployeeNo} placeholder="Employee Number"/>
                            </div>
                        </div>
                        {/* <div className="p-col-12 p-md-6 p-lg-4">
                            <label className="labeltop" htmlFor="textarea">Employee Group ID <span className="requiredColor">*</span></label>
                            <div className="mt1">
                                <Dropdown className="p-col-12" options={this.props.employeeGroup} value={this.state.EmpGroupId} 
                            onChange={e => this.handleChange(e)}  name="EmpGroupId" {...DROPDOWN_CONFIG} />
                            </div>	
                        </div> */}

                        <div className="p-col-12 p-md-6 p-lg-4">
                            <label className="labeltop" htmlFor="textarea">Employee Grade<span className="requiredColor">*</span></label>
                            <div className="mt1">
                                
                                {/* <InputText className="p-col-12" name="grade" onChange={this.handleChange} value={this.state.grade} placeholder="Employee Grade"/> */}
                                <Dropdown className="p-col-12" options={this.props.empgrade} value={this.state.EmployeeGradeNo} 
                                    onChange={this.handleChange}  name="grade" {...DROPDOWN_CONFIG} />
                            </div>	
                        </div>
                        {/* <div className="p-col-12 p-md-6 p-lg-4">
                            <label className="labeltop" htmlFor="textarea">Cost Center <span className="requiredColor">*</span></label>
                            <div className="mt1">
                                <InputText className="p-col-12" name="Costcenter" onChange={this.handleChange} value={this.state.Costcenter} placeholder="Cost Center"/>
                            </div>	
                        </div> */}

                        <div className="p-col-12 p-md-6 p-lg-4">
                            <label className="label">Cost Center <span className="requiredColor">*</span></label>
                                <div className="mt1"> <Dropdown className="p-col-12" options={this.props.costcenterapco} value={this.state.Costcenter} 
                                    onChange={this.handleChange} placeholder="Select Cost Center" name="Costcenter" {...DROPDOWN_CONFIG}/></div>
                        </div>    

                        <div className="p-col-12 p-md-6 p-lg-4">
                            <label className="labeltop" htmlFor="textarea">Gender<span className="requiredColor">*</span></label>
                            <div className="p-grid" style={{ marginTop: '0.5em'}}>
                                <div className="p-col-12 p-md-6">
                                        <RadioButton value="male" name="Gender" onChange={event => this.setState({ Gender: 1 })}  checked={this.state.Gender === 1 || this.state.Gender === "1"}  />
                                    <label htmlFor="rb1" className="p-radiobutton-label">Male</label>
                                </div>
                                <div className="p-col-12 p-md-6">
                                    {/* <RadioButton value="female" name="Gender" onChange={event => this.setState({ Gender: 0 })}  checked={this.state.Gender !== 1}/> */}
                                    <RadioButton value="female" name="Gender" onChange={event => this.setState({ Gender: 2 })}  checked={this.state.Gender === 2 || this.state.Gender === "2"}/>
                                    <label htmlFor="rb1" className="p-radiobutton-label">Female</label>
                                </div>
                            </div>
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-4">
                            <label className="labeltop" htmlFor="textarea">Employee Status<span className="requiredColor">*</span></label>
                            <div className="mt1">
                                    <Dropdown className="p-col-12" options={this.props.employeestatus} value={this.state.status} 
                                    onChange={e => this.handleChange(e)}  name="status" {...DROPDOWN_CONFIG} />
                            </div>
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-4">
                            <label className="labeltop" htmlFor="textarea">Demobilization Status<span className="requiredColor">*</span></label>
                            <div className="mt1">
                                    <Dropdown className="p-col-12" options={this.props.demobilizestatus} value={this.state.demobilizestatus} 
                                    onChange={e => this.handleChange(e)}  name="demobilizestatus" {...DROPDOWN_CONFIG} disabled={true}/>
                            </div>
                        </div>     
                        <div className="p-col-12 p-md-6 p-lg-4">
                        <label className="labeltop" htmlFor="textarea">Demobilize Date</label>
                        <div className="mt1">
                            <Calendar className="width100" placeholder="Demobilize Date" name="demobilizedate" value={this.state.demobilizedate} onChange={this.handleChange} disabled={true}/>
                        </div>
                    </div>        
                    <div className="p-col-12 p-md-6 p-lg-4">
                <label className="labeltop" htmlFor="textarea">Demobilize Remark</label>
                <div className="mt1">
                    <InputText className="p-col-12" name="demobilizeremark" onChange={this.handleChange} value={this.state.demobilizeremark} placeholder="Demobilize Remark" disabled={true}/>
                </div>
                </div>               
                        <div className="p-col-12 p-md-6 p-lg-4">
                            <label className="labeltop" htmlFor="input">Nationality <span className="requiredColor">*</span></label>
                            <div className="mt1">
                                    <Dropdown className="p-col-12" options={this.props.nationality} value={this.state.nationId} 
                                    // <Dropdown className="p-col-12" options={this.props.nationality} value={this.state.nationality} 
                                    onChange={e => this.handleChange(e)} placeholder="Select Nationality" name="nationId" {...DROPDOWN_CONFIG} />
                            </div>
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-4">
                            <label className="labeltop" htmlFor="input">Religion <span className="requiredColor">*</span></label>
                            <div className="mt1">
                                    <Dropdown className="p-col-12" options={this.props.RELIGION} value={this.state.religion} 
                                    onChange={e => this.handleChange(e)} placeholder="Select Religion" name="religion" {...DROPDOWN_CONFIG} />
                            </div>
                        </div>    

                    </div>
                    </div>
                    </div>


              
                    <div className="p-col-12" >
                    <div className="card card-w-title">
                        <h1>Name</h1>
                        
                            <div className="p-grid">

                                <div className="p-col-12 p-md-6 p-lg-4">
                                    <label className="labeltop" htmlFor="textarea">First Name <span className="requiredColor">*</span></label>
                                    <div className="mt1">
                                        <InputText className="p-col-12" name="Firstname" onChange={this.handleChange} value={this.state.Firstname} placeholder="First Name"/>
                                    </div>	
                                </div>
                                <div className="p-col-12 p-md-6 p-lg-4">
                                    <label className="labeltop" htmlFor="textarea">Middle Name </label>
                                    <div className="mt1">
                                        <InputText className="p-col-12" name="Middlename" onChange={this.handleChange} value={this.state.Middlename} placeholder="Middle Name"/>
                                    </div>	
                                </div>

                                <div className="p-col-12 p-md-6 p-lg-4">
                                    <label className="labeltop" htmlFor="textarea">Last Name <span className="requiredColor">*</span></label>
                                    <div className="mt1">
                                        <InputText className="p-col-12" name="Lastname" onChange={this.handleChange} value={this.state.Lastname} placeholder="Last Name"/>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-6 p-lg-4">
                                    <label className="labeltop" htmlFor="textarea">First Name (Arabic)</label>
                                    <div className="mt1">
                                        <InputText className="p-col-12" name="FirstnameAr" onChange={this.handleChange} value={this.state.FirstnameAr} placeholder="First Name (Arabic)"/>
                                    </div>	
                                </div>
                                <div className="p-col-12 p-md-6 p-lg-4">
                                    <label className="labeltop" htmlFor="textarea">Middle Name (Arabic)</label>
                                    <div className="mt1">
                                        <InputText className="p-col-12" name="MiddlenameAr" onChange={this.handleChange} value={this.state.MiddlenameAr} placeholder="Middle Name (Arabic)"/>
                                    </div>	
                                </div>
                                <div className="p-col-12 p-md-6 p-lg-4">
                                    <label className="labeltop" htmlFor="textarea">Last Name (Arabic)</label>
                                    <div className="mt1">
                                        <InputText className="p-col-12" name="LastnameAr" onChange={this.handleChange} value={this.state.LastnameAr} placeholder="Last Name (Arabic)"/>
                                    </div>	
                                </div>

                            </div>

                    </div>
                    </div> 

                    <div className="p-col-12" >
                    <div className="card card-w-title">
                        <h1>Contact</h1>
                        
                            <div className="p-grid">

                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="labeltop" htmlFor="textarea">Internal E-Mail <span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="internalEmail" onChange={this.handleChange} value={this.state.internalEmail} placeholder="Internal E-Mail"/>
                                </div>	
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="labeltop" htmlFor="textarea">Emergency Contact</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="phoneNo" onChange={this.handleChange} value={this.state.phoneNo} placeholder="Emergency Contact"/>
                                </div>	
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="labeltop" htmlFor="textarea">Mobile No</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="mobileNo" onChange={this.handleChange} value={this.state.mobileNo} placeholder="Mobile No"/>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="labeltop" htmlFor="textarea">Apco Mobilenumber</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="apcomobilenumber" onChange={this.handleChange} value={this.state.apcomobilenumber} placeholder="Apco Mobile Number"/>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="labeltop" htmlFor="textarea">Address</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="address" onChange={this.handleChange} value={this.state.address} placeholder="Address"/>
                                </div>
                            </div>


                            </div>

                    </div>
                    </div>

                    <div className="p-col-12" >
                                <div className="card card-w-title">
                                    <h1>Dates</h1>
                                    
                                    <div className="p-grid">

                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label  className="label">Date of Birth</label>
                                            <div className="mt1"><Calendar className="width100" placeholder="Date of Birth" name="DateOfBirth"  value={this.state.DateOfBirth} onChange={this.handleChange}/></div>                               
                                        </div>
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label  className="label">Date of Join</label>
                                            <div className="mt1"><Calendar className="width100" placeholder="Date of Join" name="DateOfJoin"  value={this.state.DateOfJoin} onChange={this.handleChange}/></div>                               
                                        </div>
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label  className="label">Confirmation Date</label>
                                            <div className="mt1"><Calendar className="width100" placeholder="Confirmation Date" name="Confirmationdate"  value={this.state.Confirmationdate} onChange={this.handleChange}/></div>                               
                                        </div>
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label  className="label">Termination Date</label>
                                            <div className="mt1"><Calendar className="width100" placeholder="Termination Date" name="terminationDate"  value={this.state.terminationDate} onChange={this.handleChange}/></div>                               
                                        </div>
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label  className="label">Appointment Letter Date</label>
                                            <div className="mt1"><Calendar className="width100" placeholder="Appointment Letter Date" name="Appointmentletterdt"  value={this.state.Appointmentletterdt} onChange={this.handleChange}/></div>                               
                                        </div>
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label  className="label">Apco Card Expiry Date</label>
                                            <div className="mt1"><Calendar className="width100" placeholder="Apco Card Expiry Date" name="apcocardexpirydate"  value={this.state.apcocardexpirydate} onChange={this.handleChange}/></div>                               
                                        </div>
                                        

                                    </div>

                                </div>
                    </div>  
            
                    <div className="p-col-12" >
                    <div className="card card-w-title">
                        <h1>Other Detail</h1>
                        
                            <div className="p-grid">

                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="labeltop" htmlFor="textarea">Visa Status <span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="visastatus" onChange={this.handleChange} value={this.state.visastatus} placeholder="Visa Status"/>
                                </div>	
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="labeltop" htmlFor="textarea">Visa Type</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="visatype" onChange={this.handleChange} value={this.state.visatype} placeholder="Visa Type"/>
                                </div>	
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="labeltop" htmlFor="textarea">Probation Period</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="probationperiod" onChange={this.handleChange} value={this.state.probationperiod} placeholder="Probation Period"/>
                                </div>
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="labeltop" htmlFor="textarea">Camp Allotted</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="campallotted" onChange={this.handleChange} value={this.state.campallotted} placeholder="Camp Allotted"/>
                                </div>
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="labeltop" htmlFor="textarea">Seniority</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="seniority" onChange={this.handleChange} value={this.state.seniority} placeholder="Camp Allotted"/>
                                </div>
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="labeltop" htmlFor="textarea">Sponsor</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="sponsor" onChange={this.handleChange} value={this.state.sponsor} placeholder="Sponsor"/>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="labeltop" htmlFor="textarea">Apco Card No</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="apcocardno" onChange={this.handleChange} value={this.state.apcocardno} placeholder="Apco Card No"/>
                                </div>
                            </div>
                            
                            {/* <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="labeltop" htmlFor="textarea">Sponsor</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="sponsor" onChange={this.handleChange} value={this.state.sponsor} placeholder="Sponsor"/>
                                </div>
                            </div> */}
                            {/* <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="labeltop" htmlFor="textarea">Sponsor</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="sponsor" onChange={this.handleChange} value={this.state.sponsor} placeholder="Sponsor"/>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="labeltop" htmlFor="textarea">Sponsor</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="sponsor" onChange={this.handleChange} value={this.state.sponsor} placeholder="Sponsor"/>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="labeltop" htmlFor="textarea">Sponsor</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="sponsor" onChange={this.handleChange} value={this.state.sponsor} placeholder="Sponsor"/>
                                </div>
                            </div> */}


                            </div>

                    </div>
                    </div>

                    <div className="p-col-12" >
                    <div className="card card-w-title">
                        <h1>Restaurant Related Details</h1>

                            <div className="p-grid">
                                <div className="p-col-12 p-md-6 p-lg-4">
                                    <label className="labeltop">Father Name</label>
                                    <div className="mt1">
                                        <InputText className="p-col-12" name="fatherName" onChange={this.handleChange} value={this.state.fatherName} placeholder="Father Name"/>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-6 p-lg-4">
                                    <label className="labeltop">Work Location</label>
                                    <div className="mt1">
                                        <InputText className="p-col-12" name="workLocation" onChange={this.handleChange} value={this.state.workLocation} placeholder="Work Location"/>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-6 p-lg-4">
                                    <label className="labeltop">Daily Work Hours</label>
                                    <div className="mt1">
                                        <InputText className="p-col-12" name="dailyWorkHours" onChange={this.handleChange} value={this.state.dailyWorkHours} placeholder="Daily Work Hours"/>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-6 p-lg-4">
                                    <label className="labeltop">Break</label>
                                    <div className="mt1">
                                        <InputText className="p-col-12" name="breakTime" onChange={this.handleChange} value={this.state.breakTime} placeholder="Break"/>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-6 p-lg-4">
                                    <label className="labeltop">Notice Period</label>
                                    <div className="mt1">
                                        <InputText className="p-col-12" name="noticePeriod" onChange={this.handleChange} value={this.state.noticePeriod} placeholder="Notice Period"/>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-6 p-lg-4">
                                    <label className="labeltop">Weekly Off</label>
                                    <div className="mt1">
                                        <Dropdown className="p-col-12" placeholder="Select Weekly Off" options={WEEKLY_OFF_OPTIONS} optionLabel="label" optionValue="id" value={this.state.weeklyOff}
                                            onChange={this.handleChange} name="weeklyOff" {...DROPDOWN_CONFIG} />
                                    </div>
                                </div>
                            </div>

                    </div>
                    </div>
            </div>
        );
        
        let secondGrid = (
            <div className="p-grid mt1">
                <div className="p-col-12 p-lg-12 mt2">
                <h1>Dependent Details</h1>
                <Button style={{float: 'right',position: 'relative', top: '-4em'}} label="Add Depedent" icon="pi pi-plus" onClick={this.addDept} />
                    { this.state.dependentDetails.length > 0 && 
                        <>
                            {this.state.dependentDetails.map((depedent,index) => {
                            return(
                                <div className="p-col-12" key={depedent.id}>
                                <div className="card card-w-title">
                                    <h1>Dependent Details {index + 1}</h1>
                                    <Link style={{float: 'right',position: 'relative', top: '-4em'}} to="#" onClick={() => this.removeDept(index)} name={depedent.id} title={`Remove Dependent ${index + 1}`}><Button icon="pi pi-trash"/></Link>
                                    
                                    <div className="p-grid">
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label">Dependent name</label>
                                             <div className="mt1"><InputText className="p-col-12" name="name" value={depedent.name || ''} placeholder="Dependent name" onChange={(e) => this.updateDependent(e, index)} /></div>
                                        </div>
                                        <div className="p-col-12 p-md-6 p-lg-5">
                                            <label className="label">Dependent Relation</label>
                                            <div className="mt1"> 
                                            
                                            <Dropdown className="p-col-12" placeholder="Select Dependent Relation" options={this.props.relationType} value={depedent.relation || ''} 
                            onChange={(e) => this.updateDependent(e, index)}  name="relation" {...DROPDOWN_CONFIG} />
                                            </div>
                                        </div>
                                        
                                        <div className="p-col-12 p-md-6 p-lg-3">
                                            <label className="label">Age</label>
                                            <div className="mt1"> <InputText className="p-col-12" name="age" placeholder="Age" maxLength="2" value={depedent.age || ''} onChange={(e) => this.updateDependent(e, index)} /></div>
                                        </div>

                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label">Gender</label>
                                            <div className="p-grid" style={{ marginTop: '0.5em'}}>
                                                <div className="p-col-12 p-md-6">
                                                    <RadioButton value="Male" name="gender" checked={depedent.gender.toLowerCase() === ('Male').toLowerCase()} onChange={(e) => this.updateDependent(e, index)} />
                                                    <label htmlFor="rb1" className="p-radiobutton-label">Male</label>
                                                </div>
                                                <div className="p-col-12 p-md-6">
                                                    <RadioButton   value="Female" name="gender"  checked={depedent.gender.toLowerCase() === ('Female').toLowerCase()} onChange={(e) => this.updateDependent(e, index)} />
                                                    <label htmlFor="rb2" className="p-radiobutton-label">Female</label>
                                                </div>
                                            </div>
                                        </div>


                                        <div className="p-col-12 p-md-6 p-lg-6">
                                            <label className="label">Present Location</label>
                                            <div className="p-grid" style={{ marginTop: '0.5em'}}>
                                                <div className="p-col-12 p-md-4">
                                                    <RadioButton value="In KSA" name="location" onChange={(e) => this.updateDependent(e, index)} checked={depedent.location === "In KSA"}/>
                                                    <label htmlFor="rb1" className="p-radiobutton-label">In KSA</label>
                                                </div>
                                                <div className="p-col-12 p-md-4">
                                                    <RadioButton value="Out of KSA" name="location" onChange={(e) => this.updateDependent(e, index)} checked={depedent.location=== "Out of KSA"}/>
                                                    <label htmlFor="rb2" className="p-radiobutton-label">Out of KSA</label>
                                                </div>
                                        </div>
                                        </div>

                                    
                                    </div>
                                </div>
                            </div>  
            
                                )

                            })}
                        </>
                        }

                </div>
            </div>

        )
        let thirdGrid = (                            
            <div className="p-grid mt1">
                <div className="p-col-12 p-md-6 p-md-offset-3 p-lg-6 p-lg-offset-3">
                    <div className="p-col-12">
                        <label className="labeltop" htmlFor="input">Position <span className="requiredColor">*</span></label>
                    </div>
                    <div className="p-col-12 ">
                            <Dropdown className="p-col-12" placeholder="Select Position" options={this.props.positionList} value={this.state.selectedPosition} 
                            onChange={e => this.handleChange(e)}  name="selectedPosition" {...DROPDOWN_CONFIG} />
                    </div>	


                    <div className="p-col-12">
                    <label className="labeltop" htmlFor="textarea">Executive </label>
                    </div>
                    <div className="p-col-12 ">
                       <Dropdown className="p-col-6" options={this.props.Executive} value={this.state.selectedExecutive} 
                            onChange={e => this.handleChange(e)}  name="selectedExecutive" {...DROPDOWN_CONFIG} />
                        {'   '}
                                    <RadioButton value="isExecutive" name="org" onChange={event => this.setState({isExecutive: true,isSection: false,isUnc:false,isDepartment:false,isPresident:false,isDivision:false})} checked={this.state.isExecutive === true}  />
                                    <label htmlFor="rb1" className="p-radiobutton-label">IS EXECUTIVE</label>
                     

                        {/* <div className="p-col-6 inputSwitch">
                        <InputSwitch checked={this.state.isExecutive} value={this.state.isExecutive} name="isExecutive" onChange={this.handleChange} />
                        <label>IS EXECUTIVE</label>
                        </div> */}
                       
                    </div>	

                    <div className="p-col-12">
                    <label className="labeltop" htmlFor="textarea">Vice President </label>
                    </div>
                    <div className="p-col-12 ">
                       <Dropdown className="p-col-6" options={this.props.VicePresident} value={this.state.selectedVicePresident} 
                            onChange={e => this.handleChange(e)} name="selectedVicePresident" {...DROPDOWN_CONFIG} />
                        {'   '}
                                    <RadioButton value="isPresident" name="org" onChange={event => this.setState({isPresident: true,isSection: false,isUnc:false,isDepartment:false,isExecutive:false,isDivision:false})}  checked={this.state.isPresident === true}  />
                                    <label htmlFor="rb1" className="p-radiobutton-label">IS VICE PRESIDENT</label>
                        {/* <div className="p-col-6 inputSwitch">
                        <InputSwitch checked={this.state.isPresident} value={this.state.isPresident} name="isPresident" onChange={this.handleChange} />
                        <label>IS VICE PRESIDENT</label>
                        </div> */}
                       
                    </div>	


                    <div className="p-col-12">
                    <label className="labeltop" htmlFor="textarea">Division</label>
                    </div>
                    <div className="p-col-12 ">
                       <Dropdown className="p-col-6" options={this.props.Division} value={this.state.selectedDivision} 
                            onChange={e => this.handleChange(e)} name="selectedDivision" {...DROPDOWN_CONFIG} />
                     {'   '}
                                    <RadioButton value="isDivision" name="org" onChange={event => this.setState({isDivision: true,isSection: false,isUnc:false,isDepartment:false,isPresident:false,isExecutive:false})} checked={this.state.isDivision === true}  />
                                    <label htmlFor="rb1" className="p-radiobutton-label">IS DIVISION</label>
                        {/* <div className="p-col-6 inputSwitch">
                        <InputSwitch checked={this.state.isDivision} value={this.state.isDivision} name="isDivision" onChange={this.handleChange} />
                        <label>IS DIVISION</label>
                        </div> */}
                    </div>	


                    <div className="p-col-12">
                    <label className="labeltop" htmlFor="textarea">Department </label>
                    </div>
                    <div className="p-col-12 ">
                       <Dropdown className="p-col-6" options={this.props.Department} value={this.state.selectedDepartment} 
                            onChange={e => this.handleChange(e)} name="selectedDepartment" {...DROPDOWN_CONFIG} />
                       {'   '}
                                    <RadioButton value="isDepartment" name="org"  onChange={event => this.setState({isDepartment: true,isSection: false,isUnc:false,isPresident:false,isExecutive:false,isDivision:false})} checked={this.state.isDepartment === true}  />
                                    <label htmlFor="rb1" className="p-radiobutton-label">IS DEPARTMENT</label>
                        {/* <div className="p-col-6 inputSwitch">
                        <InputSwitch checked={this.state.isDepartment} value={this.state.isDepartment} name="isDepartment" onChange={this.handleChange} />
                        <label>IS DEPARTMENT</label>
                        </div> */}
                    </div>	


                    <div className="p-col-12">
                    <label className="labeltop" htmlFor="textarea">Section </label>
                    </div>
                    <div className="p-col-12 ">
                       <Dropdown className="p-col-6" options={this.props.Section} value={this.state.selectedSection} 
                            onChange={e => this.handleChange(e)} name="selectedSection" {...DROPDOWN_CONFIG} />
                     {'   '}
                                    <RadioButton value="isSection" name="org" onChange={event => this.setState({isSection: true,isUnc:false,isDepartment:false,isPresident:false,isExecutive:false,isDivision:false})} checked={this.state.isSection === true}  />
                                    <label htmlFor="rb1" className="p-radiobutton-label">IS SECTION</label>
                        {/* <div className="p-col-6 inputSwitch">
                        <InputSwitch checked={this.state.isSection} value={this.state.isSection} name="isSection" onChange={this.handleChange} />
                        <label>IS SECTION</label>
                        </div> */}
                    </div>	


                    <div className="p-col-12">
                    <label className="labeltop" htmlFor="textarea">Uncategorized ORG </label>
                    </div>
                    <div className="p-col-12 ">
                       <Dropdown className="p-col-6" options={this.props.UnCategorized} value={this.state.selectedUNC} 
                            onChange={e => this.handleChange(e)} name="selectedUNC" {...DROPDOWN_CONFIG} />
                     {'   '}
                                    <RadioButton value="isUnc" name="org" onChange={event => this.setState({isUnc: true,isSection: false,isDepartment:false,isPresident:false,isExecutive:false,isDivision:false})} checked={this.state.isUnc === true}  />
                                    <label htmlFor="rb1" className="p-radiobutton-label">IS UNC</label>
                        {/* <div className="p-col-6 inputSwitch">
                        <InputSwitch checked={this.state.isUnc} value={this.state.isUnc} name="isUnc" onChange={this.handleChange} />
                        <label>IS UNC</label>
                        </div> */}
                    </div>	

                    

             
                  
                </div>
            
                <div className="p-col-12 p-md-12 p-lg-9">
                    <div className="card card-w-title">
                        <h1>Shift and Pay Data</h1>    
                    <div className="p-grid">
                        {/* <div className="p-col-12 p-md-6 p-lg-4">
                            <label className="label">Shift Pattern(Work Rule) <span className="requiredColor">*</span></label>
                                <div className="mt1"> <Dropdown className="p-col-12" options={this.props.ShiftPattern} value={this.state.shiftpatternId} 
                                    onChange={this.handleChange} placeholder="Select Shift Pattern/Work Rule" name="shiftpatternId" {...DROPDOWN_CONFIG}/></div>
                        </div> */}

    
                        <div className="p-col-12 p-md-6 p-lg-4">
                            <label className="label">Personal Area <span className="requiredColor">*</span></label>
                                <div className="mt1"> <Dropdown className="p-col-12" options={this.props.personalarea} value={this.state.persarea} 
                                    onChange={this.handleChange} placeholder="Select Persoanl Area" name="persarea" {...DROPDOWN_CONFIG}/></div>
                        </div>  

                        <div className="p-col-12 p-md-6 p-lg-4">
                            <label className="label">Persoanl Sub Area <span className="requiredColor">*</span></label>
                                <div className="mt1"> <Dropdown className="p-col-12" options={this.props.personalsubarea} value={this.state.perssubarea} 
                                    onChange={this.handleChange} placeholder="Select Persoanl Sub Area" name="perssubarea" {...DROPDOWN_CONFIG}/></div>
                        </div>                              
                        <div className="p-col-12 p-md-6 p-lg-4">
                            <label className="label">Pay Type <span className="requiredColor">*</span></label>
                                <div className="mt1"> <Dropdown className="p-col-12" options={this.props.paytype} value={this.state.paytype} 
                                    onChange={this.handleChange} placeholder="Select Shift Pattern" name="paytype" {...DROPDOWN_CONFIG}/></div>
                            </div>  
                            
                    {/* <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Pay Type</label>
                        <div className="mt1">
                        <InputText className="p-col-12" name="YearL" onChange={event => this.setState({paytype: event.target.value})}  value={this.state.paytype} placeholder="Enter Year"/>
                        </div>                             
                    </div>  */}
                    {/* <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Personal Area</label>
                        <div className="mt1">
                        <InputText className="p-col-12" name="YearL" onChange={event => this.setState({persarea: event.target.value})}  value={this.state.persarea} placeholder="Enter Year"/>
                        </div>                             
                    </div> 
                            
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Personal Sub Area</label>
                        <div className="mt1">
                        <InputText className="p-col-12" name="YearL" onChange={event => this.setState({perssubarea: event.target.value})}  value={this.state.perssubarea} placeholder="Enter Year"/>
                        </div>                             
                    </div>   */}
                    <div className="p-col-12 p-md-6 p-lg-4">
                        <label className="label">Employee Group<span className="requiredColor">*</span></label>
                        <div className="mt1"> <Dropdown className="p-col-12" options={this.props.employeegroup} value={this.state.empgrp} 
                        onChange={this.handleChange} placeholder="Select Employee Group" name="empgrp" {...DROPDOWN_CONFIG}/></div>
                    </div>  
                    <div className="p-col-12 p-md-6 p-lg-4">
                        <label className="label">Employee Sub Group<span className="requiredColor">*</span></label>
                        <div className="mt1"> <Dropdown className="p-col-12" options={this.props.employeesubgroup} value={this.state.empsubgrp} 
                        onChange={this.handleChange} placeholder="Select Employee Sub Group" name="empsubgrp" {...DROPDOWN_CONFIG}/></div>
                    </div>                     
{/* 
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Employee Group</label>
                        <div className="mt1">
                        <InputText className="p-col-12" name="YearL" onChange={event => this.setState({empgrp: event.target.value})}  value={this.state.empgrp} placeholder="Enter Year"/>
                        </div>                             
                    </div> 
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Employee Sub Group</label>
                        <div className="mt1">
                        <InputText className="p-col-12" name="YearL" onChange={event => this.setState({empsubgrp: event.target.value})}  value={this.state.empsubgrp} placeholder="Enter Year"/>
                        </div>                             
                    </div>          */}
                    <div className="p-col-12 p-md-6 p-lg-4">
                        <label className="label">Payroll Area<span className="requiredColor">*</span></label>
                        <div className="mt1"> <Dropdown className="p-col-12" options={this.props.payrollarea} value={this.state.payrollarea} 
                        onChange={this.handleChange} placeholder="Select Payroll Area" name="payrollarea" {...DROPDOWN_CONFIG}/></div>
                    </div> 

                    <div className="p-col-12 p-md-6 p-lg-4">
                        <label className="label">Work Rule<span className="requiredColor">*</span></label>
                        <div className="mt1"> <Dropdown className="p-col-12" options={this.props.ShiftPattern} value={this.state.workrule} 
                        onChange={this.handleChange} placeholder="Select Work Rule" name="workrule" {...DROPDOWN_CONFIG}/></div>
                    </div>  
                    {/* <div className="p-col-12 p-md-6 p-lg-4">
                        <label className="label">Pay Level<span className="requiredColor">*</span></label>
                        <div className="mt1"> <Dropdown className="p-col-12" options={this.props.Paylevel} value={this.state.paylevel} 
                        onChange={this.handleChange} placeholder="Select Pay Level" name="paylevel" {...DROPDOWN_CONFIG}/></div>
                    </div>  */}

                    <div className="p-col-12 p-md-6 p-lg-4">
                        <label className="label">Project<span className="requiredColor">*</span></label>
                        <div className="mt1"> <Dropdown className="p-col-12" options={this.props.project} value={this.state.project}  //changed
                        onChange={this.handleChange} placeholder="Select Project" name="project" {...DROPDOWN_CONFIG}/></div>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-4">
                        <label className="label">Salary Status<span className="requiredColor">*</span></label>
                        <div className="mt1"> <Dropdown className="p-col-12" options={this.props.salarytype} value={this.state.salarytype} 
                        onChange={this.handleChange} placeholder="Select Salary Type" name="salarytype" {...DROPDOWN_CONFIG}/></div>
                    </div> 

                    <div className="p-col-12 p-md-6 p-lg-4">
                        <label className="label">Saudi / Non Saudi<span className="requiredColor">*</span></label>
                        <div className="mt1"> <Dropdown className="p-col-12" options={this.props.saudinonsaudi} value={this.state.saudinonsaudi} 
                        onChange={this.handleChange} placeholder="Select Contract Type" name="saudinonsaudi" {...DROPDOWN_CONFIG}/></div>
                    </div> 
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Hourly Rate</label>
                        <div className="mt1">
                        <InputText className="p-col-12" name="YearL" onChange={event => this.setState({hourlyrate: event.target.value})}  value={this.state.hourlyrate} placeholder="Hourly Rate"/>
                        </div>                             
                    </div>  
                    <div className="p-col-12 p-md-6 p-lg-4">
                        <label className="label">Agreement<span className="requiredColor">*</span></label>
                        <div className="mt1"> <Dropdown className="p-col-12" options={this.props.agreement} value={this.state.agreement} 
                        onChange={this.handleChange} placeholder="Select Agreement" name="agreement" {...DROPDOWN_CONFIG}/></div>
                    </div>         


                            
                    {/* <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Work Rule</label>
                        <div className="mt1">
                        <InputText className="p-col-12" name="YearL" onChange={event => this.setState({workrule: event.target.value})}  value={this.state.workrule} placeholder="wWrk Rule"/>
                        </div>                             
                    </div>        
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Pay Level</label>
                        <div className="mt1">
                        <InputText className="p-col-12" name="YearL" onChange={event => this.setState({paylevel: event.target.value})}  value={this.state.paylevel} placeholder="Enter Year"/>
                        </div>                             
                    </div>        
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Project</label>
                        <div className="mt1">
                        <InputText className="p-col-12" name="YearL" onChange={event => this.setState({project: event.target.value})}  value={this.state.project} placeholder="Project"/>
                        </div>                             
                    </div>           */}
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Profession</label>
                        <div className="mt1">
                        <InputText className="p-col-12" name="profession" onChange={event => this.setState({profession: event.target.value})}  value={this.state.profession} placeholder="Profession"/>
                        </div>                             
                    </div>          
     


                    </div>
                    </div>
                    </div>
                

            
            </div>	
        );         
        
        // let fourthGrid = (
        //     <>
        //     <div className="mt3">
        //         <div className="p-col-12 p-md-12" style={{textAlign:'right',paddingRight:'0px'}}>
        //             <Button label="Add" style={{marginBottom:'10px'}} className="p-button-primary" onClick={this.documentAdd}/>
        //         </div>
        
        //         <DataTable className="animated fadeIn" rowHover  responsive value={this.state.depTypes} editable={true} editMode="cell"> 
        //         <Column field="DocType" header="Type" editor={this.typeEditor} style={{height: '3.5em'}}/>
        //         <Column field="DocDocumentType" header="Document Type" editor={this.docTypeEditor} style={{height: '3.5em'}}/>
        //         <Column field="DocDocumentNo" header="Document No" editor={this.noEditor} style={{height: '3.5em'}}/>
        //         <Column field="DocExpiryDate" header="Expiry Date" editor={this.expiryEditor} style={{height: '3.5em'}}/>
        //         <Column field="DocIssuDate" header="Issued Date" editor={this.issuedEditor} style={{height: '3.5em'}}/>
        //         <Column field="DocIssuPlace" header="Issued Place" editor={this.placeEditor} style={{ height: '3.5em' }} />
        //         <Column field="Expiryarabic" header="Expiry Date-Hijri" editor={this.HijriDateEditor} style={{height: '3.5em'}}/> 
        //         <Column field="attachment" header="Attachment" body={(rowData, props) => (<input type="file"  accept=".pdf,.jpg,.jpeg,.png"  onChange={e => this.handleDocumentAttachment(e, props.rowIndex)} /> )} style={{ height: '3.5em' }}/>       
        //         <Column body={this.actionTemplate} style={{textAlign:'center', width: '8em'}}/>
        //     </DataTable> 
        //     </div>
        //     </>
   
            
            
            
        // )

        //new Fourth Grid For documents 
        let fourthGrid = (
            <>
             <div>
                <div className="mt3">
                    {/* <div className="card card-w-title"> */}
                        <h2>Add Document</h2>
                        <div className="p-grid">
                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label>Type</label>
                                <Dropdown options={[
                                    { label: 'Own', value: 'Own' },
                                    { label: 'Dependent', value: 'Dependent' }
                                ]}
                                value={this.state.documentForm.DocType}
                                onChange={e => this.setState({ documentForm: { ...this.state.documentForm, DocType: e.value } })}
                                placeholder="---Select---"
                                className="p-col-12"
                                />
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label>Document Type</label>
                                <Dropdown options={[
                                    { label: 'Passport', value: 'Passport' },
                                    { label: 'Driving License', value: 'Driving License' },
                                    { label: 'Iqama', value: 'Iqama' }
                                ]}
                                value={this.state.documentForm.DocDocumentType}
                                onChange={e => this.setState({ documentForm: { ...this.state.documentForm, DocDocumentType: e.value } })}
                                placeholder="---Select---"
                                className="p-col-12"
                                />
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label>Document No</label>
                                <InputText value={this.state.documentForm.DocDocumentNo}
                                    onChange={e => this.setState({ documentForm: { ...this.state.documentForm, DocDocumentNo: e.target.value } })}
                                    placeholder="Document No"
                                    className="p-col-12"
                                />
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label>Expiry Date</label>
                                <InputText
                                    value={this.state.documentForm.DocExpiryDate}
                                    onChange={e => this.setState({ documentForm: { ...this.state.documentForm, DocExpiryDate: e.target.value } })}
                                    placeholder="dd/mm/yyyy"
                                    className="p-col-12"
                                 />
                                {/* <Calendar
                                    value={this.state.documentForm.DocExpiryDate}
                                    onChange={e => this.setState({ documentForm: { ...this.state.documentForm, DocExpiryDate: e.value } })}
                                    placeholder="Expiry Date"
                                    className="width100"
                                     appendTo={document.body}
                                    showOnFocus={true}
                                    touchUI={false}
                                /> */}
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label>Issued Date</label>
                                <div className="mt1">
                                    <InputText className="p-col-12"
                                        value={this.state.documentForm.DocIssuDate}
                                        onChange={e => this.setState({ documentForm: { ...this.state.documentForm, DocIssuDate: e.target.value } })}
                                        placeholder="dd/mm/yyyy"
                                    />
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label>Issued Place</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" value={this.state.documentForm.DocIssuPlace}
                                        onChange={e => this.setState({ documentForm: { ...this.state.documentForm, DocIssuPlace: e.target.value } })}
                                        placeholder="Issued Place"
                                    />
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label>Expiry Date-Hijri</label>
                                <div className="mt1">
                                    <InputText className="p-col-12"
                                        value={this.state.documentForm.Expiryarabic}
                                        onChange={e => this.setState({ documentForm: { ...this.state.documentForm, Expiryarabic: e.target.value } })}
                                        placeholder="dd/mm/yyyy"
                                    />
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label>Attachment</label>
                                <div className="mt1">
                                    <label style={{color:'white',fontSize: '15px', width:'100%', backgroundColor:'#406882', borderRadius:'4px', padding: '8px', display: 'block'}}>
                                        <input type="file" className="inputfile"  name="file" id="file-document" accept=".pdf,.jpg,.jpeg,.png" onChange={(e) => this.handleDocumentAttachment(e, null)} />
                                        <strong><img src={UploadImage} alt="upload" /> Choose a File&hellip;</strong>
                                    </label>
                                    {this.state.documentForm.Attachment && (
                                        <div style={{ marginTop: '8px', color: '#28a745', fontSize: '12px' }}>
                                             {this.state.documentForm.Attachment.fileName}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-3">
                                {/* <label style={{ visibility: 'hidden' }}>.</label>
                                <div className="mt1"> */}
                                    <Button label="Add" className="p-button-primary" onClick={this.documentAdd} style={{ width: '100%' }} />
                                {/* </div> */}
                            </div>
                        </div>
                        {/* </div> */}
                    <DataTable className="animated fadeIn" rowHover responsive value={this.state.depTypes}>
                        <Column field="DocType" header="Type" style={{ height: '3.5em' }} />
                        <Column field="DocDocumentType" header="Document Type" style={{ height: '3.5em' }} />
                        <Column field="DocDocumentNo" header="Document No" style={{ height: '3.5em' }} />
                        <Column field="DocExpiryDate" header="Expiry Date" style={{ height: '3.5em' }} />
                        <Column field="DocIssuDate" header="Issued Date" style={{ height: '3.5em' }} />
                        <Column field="DocIssuPlace" header="Issued Place" style={{ height: '3.5em' }} />
                        <Column field="Expiryarabic" header="Expiry Date-Hijri" style={{ height: '3.5em' }} />
                        <Column 
                            field="Attachment" 
                            header="Attachment" 
                            body={(rowData) => (
                                rowData.Attachment ? (
                                    <Button 
                                        icon="pi pi-download" 
                                        className="p-button-secondary ml1"
                                        onClick={() => this.downloadDocument(rowData)}
                                        tooltip="Download"
                                    />
                                ) : (
                                    <span style={{color: '#999'}}>No File</span>
                                )
                            )} 
                            style={{ height: '3.5em', textAlign: 'center' }} 
                        />
                        <Column body={this.actionTemplate} style={{ textAlign: 'center', width: '8em' }} />
                    </DataTable>
                    </div>
                    </div>

                 {/* </div> */}
                 <div className="card card-w-title mt3">
                    <div className="p-grid">
                        <div className="p-col-12">
                            {/* <Attachments
                                handleAttachment={(files) => {
                                    // files is an array of uploaded file objects from Attachments component
                                    // You can store the first file's base64 or file info in documentForm.Attachment
                                    if (files && files.length > 0) {
                                        this.setState({
                                            documentForm: {
                                                ...this.state.documentForm,
                                                Attachment: files[0].base64 || files[0].filePath || files[0] // adapt to your Attachments output
                                            }
                                        });
                                    }
                                }}
                                folderName="EmployeeDocument"
                                reloadedValues={this.state.documentForm.Attachment ? [{ ...this.state.documentForm.Attachment }] : []}
                                isReloaded={false}
                            /> */}
                        </div>
                    </div>
                </div>
                <Dialog 
                    header="Upload Document Attachment" 
                    visible={this.state.showAttachmentDialog} 
                    onHide={() => this.setState({ showAttachmentDialog: false })}
                    modal
                    style={{ width: '80vw' }}
                >
                    <Attachments
                        handleAttachment={(files) => {
                            if (files && files.length > 0) {
                                const file = files[0];
                                this.setState({
                                    documentForm: {
                                        ...this.state.documentForm,
                                        Attachment: {
                                            fileExtension: file.fileExtention || file.fileExtension || '',
                                            filePath: file.filePath || '',
                                            fileName: file.fileName || file.name || '',
                                            virtualFilePath: file.virtualFilePath || '',
                                            folderName: 'EmployeeDocument'
                                        }
                                    },
                                    showAttachmentDialog: false
                                }, () => {
                                    this.growl.show({ 
                                        severity: 'success', 
                                        summary: 'Success', 
                                        detail: 'Attachment added successfully'
                                    });
                                });
                            }
                        }}
                        folderName="EmployeeDocument"
                        reloadedValues={this.state.documentForm.Attachment ? [this.state.documentForm.Attachment] : []}
                        isReloaded={false}
                    />
                </Dialog>
            </>
                )

       

        let fifthGrid = (
           
            <div className="mt3">
                <div className="p-grid">

                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Leave Type</label>
                        <div className="mt1"><Dropdown className="p-col-12" options={this.props.TimeoffType} name="leaveType" value={this.state.leaveType} onChange={event => this.setState({leaveType: event.value})} {...DROPDOWN_CONFIG} placeholder="Select Leave Type"/></div>   
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Year</label>
                        <div className="mt1">
                        <InputText className="p-col-12" name="YearL" onChange={event => this.setState({YearL: event.target.value})}  value={this.state.YearL} placeholder="Enter Year"/>
                        </div>                             
                    </div>                    
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Allocated Quota</label>
                        <div className="mt1">
                        <InputText className="p-col-12" name="allocated" onChange={event => this.setState({allocated: event.target.value})}  value={this.state.allocated} placeholder="Enter Allocated"/>
                        </div>                             
                    </div>                   
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Used Quota</label>
                        <div className="mt1">
                        <InputText className="p-col-12" name="used" onChange={event => this.setState({used: event.target.value})}  value={this.state.used} placeholder="Enter Used"/>
                        </div>                             
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label  className="label">Balance Quota</label>
                        <div className="mt1">
                            <InputText className="p-col-12" name="balance" onChange={event => this.setState({balance: event.target.value})}  value={this.state.balance} placeholder="Enter Balance"/>     
                        </div>              
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label  className="label" style={{visibility:"hidden"}}>.</label>
                        <div className="mt1">
                        <Button label="Add" disabled={!isLeaveEnabled} className="p-button-primary" onClick={this.addLeaveQuota}/>
                        </div>
                    </div>
           
                    <div className="p-col-12">
                    <DataTable className="animated fadeIn mt2" rowHover  responsive value={this.state.leaveQuota} editable={true}>
                        <Column field="leaveType" header="Leave Type" style={{ height: '3.5em' }} body={this.leaveRender} />
                        <Column field="Year" header="Year" style={{height: '3.5em'}}/>
                        <Column field="allocated" header="Allocated Days" style={{height: '3.5em'}}/>
                        <Column field="used" header="Used"  style={{height: '3.5em'}}/>
                        <Column field="balance" header="Balance" style={{ height: '3.5em' }} />
                        {/* <Column disabled="true" field="leaveQuotaId" />
                        <Column show="false" field="employeeId" />
                        <Column show="false" field="employeeNo" />     */}
                        <Column body={this.actionQuota} />
                    </DataTable> 
                    </div>

                </div>
            </div>        
    )

        let sixthGrid = (
           
            <div className="mt3">
                <div className="p-grid">

                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Ticket Type</label>
                        <div className="mt1"><Dropdown className="p-col-12" options={this.props.TicketClass} name="TicketType" value={this.state.TicketType} onChange={event => this.setState({TicketType: event.value})} {...DROPDOWN_CONFIG} placeholder="Select Ticket Type"/></div>   
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Year</label>
                        <div className="mt1">
                        <InputText className="p-col-12" name="Yeart" onChange={event => this.setState({Yeart: event.target.value})}  value={this.state.Yeart} placeholder="Year"/>
                        </div>                             
                    </div>                         
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Allocated Quota</label>
                        <div className="mt1">
                        <InputText className="p-col-12" name="allocatedt" onChange={event => this.setState({allocatedt: event.target.value})}  value={this.state.allocatedt} placeholder="Enter Allocated"/>
                        </div>                             
                    </div>                    
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Used Quota</label>
                        <div className="mt1">
                        <InputText className="p-col-12" name="usedt" onChange={event => this.setState({usedt: event.target.value})}  value={this.state.usedt} placeholder="Enter Used"/>
                        </div>                             
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label  className="label">Balance Quota</label>
                        <div className="mt1">
                            <InputText className="p-col-12" name="balancet" onChange={event => this.setState({balancet: event.target.value})}  value={this.state.balancet} placeholder="Enter Balance"/>     
                        </div>              
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label  className="label" style={{visibility:"hidden"}}>.</label>
                        <div className="mt1">
                        <Button label="Add"  className="p-button-primary" onClick={this.addTicketQuota}/>
                        </div>
                    </div>
           
                    <div className="p-col-12">
                    <DataTable className="animated fadeIn mt2" rowHover  responsive value={this.state.TicketQuota} editable={true}>
                        <Column field="TicketType" header="Ticket Type" style={{ height: '3.5em' }} body={this.TicketRender} />
                        <Column field="year" header="Year" style={{height: '3.5em'}}/>   
                        <Column field="allocated" header="Allocated Days" style={{height: '3.5em'}}/>
                        <Column field="usedQuota" header="Used"  style={{height: '3.5em'}}/>
                        <Column field="balanceQuota" header="Balance" style={{height: '3.5em'}}/>
                        <Column body={this.actionTQuota} />
                    </DataTable> 
                    </div>

                </div>
            </div>        
        )
        let seventhGrid = (
           
            <div className="mt3">
                <div className="p-grid">

                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Visa Type</label>
                        <div className="mt1"><Dropdown className="p-col-12" options={this.props.VisaType} name="visaType" value={this.state.visaType} onChange={event => this.setState({visaType: event.value})} {...DROPDOWN_CONFIG} placeholder="Select Visa Type"/></div>   
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Year</label>
                        <div className="mt1">
                        <InputText className="p-col-12" name="YearV" onChange={event => this.setState({Yearv: event.target.value})}  value={this.state.Yearv} placeholder="Year"/>
                        </div>                             
                    </div>                      
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Allocated Quota</label>
                        <div className="mt1">
                        <InputText className="p-col-12" name="allocatedV" onChange={event => this.setState({allocatedV: event.target.value})}  value={this.state.allocatedV} placeholder="Enter Allocated Quota"/>
                        </div>                             
                    </div>                   
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Used Quota</label>
                        <div className="mt1">
                        <InputText className="p-col-12" name="usedV" onChange={event => this.setState({usedV: event.target.value})}  value={this.state.usedV} placeholder="Enter Used"/>
                        </div>                             
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label  className="label">Balance Quota</label>
                        <div className="mt1">
                            <InputText className="p-col-12" name="balanceV" onChange={event => this.setState({balanceV: event.target.value})}  value={this.state.balanceV} placeholder="Enter Balance"/>     
                        </div>              
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label  className="label" style={{visibility:"hidden"}}>.</label>
                        <div className="mt1">
                        <Button label="Add"  className="p-button-primary" onClick={this.addVisaQuota}/>
                        </div>
                    </div>
           
                    <div className="p-col-12">
                    <DataTable className="animated fadeIn mt2" rowHover  responsive value={this.state.VisaQuota} editable={true}>
                        <Column field="visaType" header="Visa Type" style={{ height: '3.5em' }} body={this.VisaRender} />
                        <Column field="year" header="Year" style={{height: '3.5em'}}/>    
                        <Column field="allocated" header="Allocated Days" style={{height: '3.5em'}}/>
                        <Column field="usedQuota" header="Used"  style={{height: '3.5em'}}/>
                        <Column field="balanceQuota" header="Balance" style={{height: '3.5em'}}/>
                        <Column body={this.actionVQuota} />
                    </DataTable> 
                    </div>

                </div>
            </div>        
        )

        let eighthGrid = (
            <div className="p-col-12 p-lg-12 mt2">
                <h1>Po Details</h1>
                <Button style={{float: 'right',position: 'relative', top: '-4em'}} label="Add" icon="pi pi-plus" onClick={this.addPo} />
                    { this.state.poDetails.length > 0 && 
                        <>
                         {/* Simple reverse - show latest first
                    {[...this.state.poDetails].reverse().map((po, displayIndex) => {
                        // Get the original index for updates
                        const index= this.state.poDetails.length - 1 - displayindex; */}

                            {this.state.poDetails.map((po,index) => { 
                            return(
                                
                                <div className="p-col-12" key={po.employeePoId}>
                                <div className="card card-w-title">
                                    <h1>Po Details {po.lineItemReg}</h1>
                                     {/* Conditionally show delete button only for new entries */}
                                    {(po.employeePoId.startsWith('temp-') || po.employeePoId === '00000000-0000-0000-0000-000000000000') && (
                                        <Link style={{float: 'right',position: 'relative', top: '-4em'}} to="#" onClick={() => this.removePo(po.employeePoId)} > <Button icon="pi pi-trash"/> </Link>
                                        )}
                                    {/* name changed for all input boxes */}
                                    <div className="p-grid">
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label">PO Number</label>
                                            {/* //Update using Id insteadof index */}
                                             <div className="mt1"><InputText className="p-col-12" name="pono" value={po.pono || ''} placeholder="po name" onChange={(e) => this.updatepo(e, po.employeePoId)} /></div>
                                        </div>
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label">PO Header Text</label>
                                             <div className="mt1"><InputText className="p-col-12" name="headertext" value={po.headertext || ''} placeholder="headertext" onChange={(e) => this.updatepo(e, po.employeePoId)} /></div>
                                        </div>
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label">PO Item Text</label>
                                             <div className="mt1"><InputText className="p-col-12" name="itemdesc" value={po.itemdesc || ''} placeholder="Item Description" onChange={(e) => this.updatepo(e, po.employeePoId)} /></div>
                                        </div>
                                        {/* <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label">Vendor</label>
                                             <div className="mt1"><Dropdown className="p-col-12" name="agent" value={po.agent || ''}  options={this.props.Vendor} placeholder="agent" onChange={(e) => this.updatepo(e, po.employeePoId)} {...DROPDOWN_CONFIG}/></div>
                                        </div> */}
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label">Po Date</label>
                                             <div className="mt1"><Calendar className="p-col-12" name="podate" value={po.podate || ''} placeholder='Select Po Date' onChange={(e) => this.updatepo(e, po.employeePoId)} /></div>
                                        </div>
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label">Po Start Date</label>
                                             <div className="mt1"><Calendar className="p-col-12" name="pofrom" value={po.pofrom || ''} placeholder='Select Po Start Date' onChange={(e) => this.updatepo(e, po.employeePoId)} /></div>
                                        </div>
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label">Po End Date</label>
                                             <div className="mt1"><Calendar className="p-col-12" name="poto" value={po.poto || ''} placeholder='Select Po End Date' onChange={(e) => this.updatepo(e, po.employeePoId)} /></div>
                                        </div>
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label">Line Item Regular Hr
                                            </label>
                                             <div className="mt1"><InputText className="p-col-12" name="lineItemReg" value={po.lineItemReg || ''} placeholder='Line item Regular Hr' onChange={(e) => this.updatepo(e, po.employeePoId)} /></div>
                                        </div>
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label">Regular Hr Price
                                            </label>
                                             <div className="mt1"><InputText className="p-col-12" name="regprice" value={po.regprice || ''} placeholder='Enter Regular Hr Price' onChange={(e) => this.updatepo(e, po.employeePoId)} /></div>
                                        </div>
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label">Regular Hr Unit
                                            </label>
                                             <div className="mt1"><Dropdown className="p-col-12" name="regunit" value={po.regunit || ''} placeholder='Select Regular Hr Unit' options={this.props.salarytypen} onChange={(e) => this.updatepo(e, po.employeePoId)} {...DROPDOWN_CONFIG}/></div>
                                             {/* <div className="mt1"><InputText className="p-col-12" name="regunit" value={po.regunit || ''}  onChange={(e) => this.updatepo(e, po.employeePoId)} /></div> */}
                                        </div>
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label">Line Item OT Hr
                                            </label>
                                             <div className="mt1"><InputText className="p-col-12" name="lineItemOt" value={po.lineItemOt || ''} placeholder='Line Item OT Hr' onChange={(e) => this.updatepo(e, po.employeePoId)} /></div>
                                        </div>
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label">OT Price</label>
                                             <div className="mt1"><InputText className="p-col-12" name="otprice" value={po.otprice || ''} placeholder='Enter OT Price' onChange={(e) => this.updatepo(e, po.employeePoId)} /></div>
                                        </div>
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label">OT Unit</label>
                                             <div className="mt1"><Dropdown className="p-col-12" name="otunit" value={po.otunit || ''} placeholder='Select OT Unit' options={this.props.salarytypen} onChange={(e) => this.updatepo(e, po.employeePoId)} {...DROPDOWN_CONFIG}/></div>
                                        </div>
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label">Weekly Working HR</label>
                                             <div className="mt1"><InputText className="p-col-12" name="weeklyWorkingHr" value={po.weeklyWorkingHr || ''} placeholder='Enter Weekly Working Hr' onChange={(e) => this.updatepo(e, po.employeePoId)} /></div>
                                        </div>
                                        {/* <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label">Weekend</label>
                                            <div className="mt1">
                                            <MultiSelect 
                                                className="p-col-12" 
                                                options={weekdayOptions} 
                                                value={po.holiday|| []} 
                                                onChange={e => this.handlePoChange({ name: 'holiday', value: e.value },po.employeePoId)} 
                                                showClear={false}  
                                                placeholder="Select Days" 
                                                {...DROPDOWN_CONFIG} 
                                            />
                                            </div>
                                        </div> */}
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label">Status</label> {/* changed status to isdeleted */}                                           
                                            <div className="mt1"> 
                                            <InputSwitch checked={po.deleted === 0 || po.deleted === '0'} name="isActive"  onChange={e => { this.handlePoChange({ name: 'deleted', value: e.value ? 0 : 1 }, po.employeePoId); }} />
                                            <span style={{ marginLeft: '10px' }}> {po.deleted === 0 || po.deleted === '0' ? 'Active' : 'Inactive'}  </span>
                                        </div>
                                     </div>   
                                    </div>
                                </div>
                            </div>  
            
                                )

                            })}
                        </>
                        }

                </div> )

        let ninthGrid = (
            <div className="p-grid mt1">
                <div className="p-col-12 p-lg-12 mt2">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1em', marginBottom: '1em' }}>
                        <h1 style={{ margin: 0, flex: 1 }}>Allowance & Deduction</h1>
                        <Button 
                            label="Add Allowance/Deduction" 
                            icon="pi pi-plus" 
                            onClick={this.addAllowanceDeduction}
                            disabled={!this.state.allowanceDeductionDetails.selectedAllowanceDeduction || !this.state.allowanceDeductionDetails.allowanceDeductionAmount}
                        />
                    </div>
                    
                    <div className="p-grid" style={{ width: '100%' }}>
                        <div className="p-col-12 p-md-6 p-lg-4">
                            <label className="label">Allowance/Deduction Type <span className="requiredColor">*</span></label>
                            <div className="mt1">
                                <Dropdown 
                                    className="p-col-12" 
                                    options={this.props.AllowanceDeduction} 
                                    value={this.state.allowanceDeductionDetails.selectedAllowanceDeduction} 
                                    onChange={this.handleAllowanceDeductionChange} 
                                    placeholder="Select Allowance/Deduction" 
                                    {...DROPDOWN_CONFIG}
                                />
                            </div>
                        </div>
                        
                        <div className="p-col-12 p-md-6 p-lg-4">
                            <label className="label">Amount <span className="requiredColor">*</span></label>
                            <div className="mt1">
                                <InputText 
                                    className="p-col-12" 
                                    type="number"
                                    onChange={(e) => this.setState({ 
                                        allowanceDeductionDetails: {
                                            ...this.state.allowanceDeductionDetails,
                                            allowanceDeductionAmount: e.target.value
                                        }
                                    })} 
                                    value={this.state.allowanceDeductionDetails.allowanceDeductionAmount} 
                                    placeholder="Enter Amount"
                                />
                            </div>
                        </div>
                        
                        <div className="p-col-12 p-md-6 p-lg-4">
                            <label className="label">Unit</label>
                            <div className="mt1">
                                <Dropdown
                                    className="p-col-12"
                                    options={currencyList}
                                    value={this.state.allowanceDeductionDetails.allowanceDeductionUnit}
                                    onChange={(e) => this.setState({
                                        allowanceDeductionDetails: {
                                            ...this.state.allowanceDeductionDetails,
                                            allowanceDeductionUnit: e.value
                                        }
                                    })}
                                    placeholder="Select Unit"
                                    {...DROPDOWN_CONFIG}
                                />
                            </div>
                        </div>
                        
                        <div className="p-col-12 p-md-6 p-lg-4">
                            <label className="label">Description</label>
                            <div className="mt1">
                                <InputText 
                                    className="p-col-12" 
                                    value={this.state.allowanceDeductionDetails.allowanceDeductionDescription} 
                                    placeholder="Auto-filled from type"
                                    disabled
                                />
                            </div>
                        </div>
                    </div>

                    {this.state.allowanceDeductionQuota.length > 0 && (
                        <DataTable value={this.state.allowanceDeductionQuota.filter(item => item.isActive !== false)} style={{ marginTop: '1em' }}>
                            {/* <Column field="allowanceType" header="Type" style={{ width: '30%' }} /> */}
                            <Column field="description" header="Description" style={{ width: '25%' }} />
                            <Column field="unit" header="Unit" style={{ width: '20%' }} />
                            <Column field="amount" header="Amount" style={{ width: '25%' }} />
                            <Column 
                                body={(rowData, column) => (
                                    <Button 
                                            type="button" 
                                            icon="pi pi-trash" 
                                            className="p-button-danger" 
                                            onClick={() => this.deleteAllowanceDeduction(this.state.allowanceDeductionQuota.indexOf(rowData))}
                                        />
                                )} 
                                style={{ width: '10%' }} 
                                header="Action"
                            />
                        </DataTable>
                    )}
                </div>
            </div>
        );


          let tenthGrid = (
            <div className="p-grid mt1">
                <div className="p-col-12">
                    <div className="card card-w-title">
                        <h1>Bank Details</h1>
                        <div className="p-grid">
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">Bank Name <span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="bankName" onChange={this.handleChange} value={this.state.bankName} placeholder="Bank Name"/>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">Branch Name <span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="branchName" onChange={this.handleChange} value={this.state.branchName} placeholder="Branch Name"/>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">Account Holder Name <span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="accountHolderName" onChange={this.handleChange} value={this.state.accountHolderName} placeholder="Account Holder Name"/>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">Account Number <span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="accountNumber" onChange={this.handleChange} value={this.state.accountNumber} placeholder="Account Number"/>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">IFSC Code <span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="ifscCode" onChange={this.handleChange} value={this.state.ifscCode} placeholder="IFSC Code"/>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">IBAN Number</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="ibannumber" onChange={this.handleChange} value={this.state.ibannumber} placeholder="IBAN Number (Optional)"/>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">UPI ID</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="upiId" onChange={this.handleChange} value={this.state.upiId} placeholder="UPI ID (Optional)"/>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">Salary Account Type <span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    <Dropdown className="p-col-12" options={[{label: 'Savings', value: 'Savings'}, {label: 'Current', value: 'Current'}, {label: 'Other', value: 'Other'}]} name="salaryAccountType" value={this.state.salaryAccountType} onChange={this.handleChange} placeholder="Select Account Type" {...DROPDOWN_CONFIG}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="p-col-12">
                    <div className="card card-w-title">
                        <h1>Statutory & Compliance Details</h1>
                        <div className="p-grid">
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">PAN Number <span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="panNumber" onChange={this.handleChange} value={this.state.panNumber} placeholder="PAN Number"/>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">Aadhaar Number <span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="aadhaarNumber" onChange={this.handleChange} value={this.state.aadhaarNumber} placeholder="Aadhaar Number"/>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">UAN Number</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="uanNumber" onChange={this.handleChange} value={this.state.uanNumber} placeholder="UAN Number"/>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">PF Number</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="pfNumber" onChange={this.handleChange} value={this.state.pfNumber} placeholder="PF Number"/>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">ESI Number</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="esiNumber" onChange={this.handleChange} value={this.state.esiNumber} placeholder="ESI Number"/>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">Professional Tax State</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="ptState" onChange={this.handleChange} value={this.state.ptState} placeholder="Professional Tax State"/>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">Labour Welfare Fund Applicability</label>
                                <div className="mt1">
                                    <Dropdown className="p-col-12" options={[{label: 'Yes', value: 'Yes'}, {label: 'No', value: 'No'}]} name="lwfApplicability" value={this.state.lwfApplicability} onChange={this.handleChange} placeholder="Select" {...DROPDOWN_CONFIG}/>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">Tax Regime <span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    <Dropdown className="p-col-12" options={[{label: 'Old', value: 'Old'}, {label: 'New', value: 'New'}]} name="taxRegime" value={this.state.taxRegime} onChange={this.handleChange} placeholder="Select Tax Regime" {...DROPDOWN_CONFIG}/>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">TAN Location</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="tanLocation" onChange={this.handleChange} value={this.state.tanLocation} placeholder="TAN Location"/>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">Form 12B Submitted</label>
                                <div className="mt1">
                                    <Dropdown className="p-col-12" options={[{label: 'Yes', value: 'Yes'}, {label: 'No', value: 'No'}]} name="form12bSubmitted" value={this.state.form12bSubmitted} onChange={this.handleChange} placeholder="Select" {...DROPDOWN_CONFIG}/>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">Previous Employer Income</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="prevEmpIncome" onChange={this.handleChange} value={this.state.prevEmpIncome} placeholder="Previous Employer Income"/>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">Previous Employer Tax</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="prevEmpTax" onChange={this.handleChange} value={this.state.prevEmpTax} placeholder="Previous Employer Tax"/>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">Gratuity Number</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="gratuityNumber" onChange={this.handleChange} value={this.state.gratuityNumber} placeholder="Gratuity Number (if applicable)"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="p-col-12">
                    <div className="card card-w-title">
                        <h1>Deduction Components (in %)</h1>
                        <div className="p-grid">
                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label className="label">PF (%)</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="pfPercentage" onChange={this.handleChange} value={this.state.pfPercentage} placeholder="PF Percentage"/>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label className="label">ESI (%)</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="esiPercentage" onChange={this.handleChange} value={this.state.esiPercentage} placeholder="ESI Percentage"/>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label className="label">PT (%)</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="ptPercentage" onChange={this.handleChange} value={this.state.ptPercentage} placeholder="PT Percentage"/>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label className="label">TDS (%)</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="tdsPercentage" onChange={this.handleChange} value={this.state.tdsPercentage} placeholder="TDS Percentage"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
        
        if(this.state.activeIndex === 0){
            grid = firstGrid;
        }else if(this.state.activeIndex === 1){
            grid = secondGrid;
        }else if(this.state.activeIndex === 2){
            grid = thirdGrid;
        }else if(this.state.activeIndex === 3){
            grid = fourthGrid;
        }else if(this.state.activeIndex === 4){
            grid = fifthGrid;
        }else if(this.state.activeIndex === 5){
            grid = eighthGrid;
        }else if(this.state.activeIndex === 6){
            grid = ninthGrid;
        }else if(this.state.activeIndex === 7){
            grid = tenthGrid;
        }
        // if(this.state.activeIndex === 0){
        //     grid = firstGrid;
        // }else if(this.state.activeIndex === 1){
        //     grid = secondGrid;
        // }else if(this.state.activeIndex === 2){
        //     grid = thirdGrid;
        // }else if(this.state.activeIndex === 3){
        //     grid = fourthGrid;
        // }else if(this.state.activeIndex === 4){
        //     grid = fifthGrid;
        // }else if(this.state.activeIndex === 5){
        //     grid = sixthGrid;
        // }else if(this.state.activeIndex === 6){
        //     grid = seventhGrid;
        // }else if(this.state.activeIndex === 7){
        //     grid = eighthGrid;    
        // }else if(this.state.activeIndex === 8){
        //     grid = ninthGrid;
        // }
        

      
        return (
            <div className="p-grid employeeMaster">
                { this.props.loading && <div className="page-loader"></div>}
                { this.state.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">

                    <div className="card card-w-title">
                        <h1>Add Employee Master</h1>
                    
                    <div style={{ 
                        overflowX: 'auto', 
                        overflowY: 'hidden',
                        // marginBottom: '2em',
                        width: '100%'
                    }}>
                        <Steps model={this.state.stepsItems} activeIndex={this.state.activeIndex} onSelect={(e) => this.setState({activeIndex: e.index})} readOnly={false} />
                    </div>

                        { grid }

                        <div className="mt3">
                            <div className="p-col-12 p-md-12" style={{textAlign:'right',paddingRight:'0px'}}>

                            { (this.state.activeIndex !== 0) && <Button icon=" pi pi-chevron-left" label="Prev" style={{marginBottom:'10px'}} className="p-button-primary p-button-rounded" onClick={this.prevMove}/> }
                            
                            { (this.state.activeIndex !== (this.state.stepsItems.length-1)) && <Button icon=" pi pi-chevron-right" label="Next" style={{marginBottom:'10px'}} className="p-button-primary p-button-rounded ml1" onClick={this.nextMove}/>}

                            

                            </div>
                        </div>

                        
                    </div>

                    <FooterButton access={accessButton} disabled={false} type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData}  to={"/employee-master/"} />


                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        loading : state.master.loading,
        error : state.master.error,
        success: state.master.success,
        positionList : state.master.positionList,
        tableLists: state.master.tableLists,
        costcenterapco: (state.keyword.costcenterapco !== undefined) ? state.keyword.costcenterapco : [],
        personalsubarea: (state.keyword.personalsubarea !== undefined) ? state.keyword.personalsubarea : [],
        personalarea: (state.keyword.personalarea !== undefined) ? state.keyword.personalarea : [],
        paytype: (state.keyword.paytype !== undefined) ? state.keyword.paytype : [],
        payrollarea: (state.keyword.payrollarea !== undefined) ? state.keyword.payrollarea : [],
        employeegroup: (state.keyword.employeegroup !== undefined) ? state.keyword.employeegroup : [],
        employeesubgroup: (state.keyword.employeesubgroup !== undefined) ? state.keyword.employeesubgroup : [],
        agreement: (state.keyword.agreement !== undefined) ? state.keyword.agreement : [],
        salarytype: (state.keyword.salarytype !== undefined) ? state.keyword.salarytype : [],
        saudinonsaudi: (state.keyword.saudinonsaudi !== undefined) ? state.keyword.saudinonsaudi : [],
        RELIGION: (state.keyword.RELIGION !== undefined) ? state.keyword.RELIGION : [],
        nationality: (state.keyword.nationality !== undefined) ? state.keyword.nationality : [],
        relationType : (state.keyword.relationType!==undefined) ? state.keyword.relationType : [],
        TimeoffType: (state.keyword.TimeoffType!==undefined) ? state.keyword.TimeoffType : [],
        TicketClass: (state.keyword.TicketClass!==undefined) ? state.keyword.TicketClass : [],
        VisaType: (state.keyword.VisaType!==undefined) ? state.keyword.VisaType : [],
        employeeGroup: (state.keyword.employeeGroup!==undefined) ? state.keyword.employeeGroup : [],
        Department: (state.keyword.Department!==undefined) ? state.keyword.Department : [],
        Division: (state.keyword.Division!==undefined) ? state.keyword.Division : [],
        Section: (state.keyword.Section!==undefined) ? state.keyword.Section : [],
        UnCategorized: (state.keyword.UnCategorized!==undefined) ? state.keyword.UnCategorized : [],
        VicePresident: (state.keyword.VicePresident!==undefined) ? state.keyword.VicePresident : [],
        Executive: (state.keyword.Executive !== undefined) ? state.keyword.Executive : [],
        ShiftPattern: (state.keyword.ShiftPattern !== undefined) ? state.keyword.ShiftPattern : [],
        Vendor: (state.keyword.Vendor !== undefined) ? state.keyword.Vendor : [],
        project: (state.keyword.project!==undefined) ? state.keyword.project : [],
        salarytypen: (state.keyword.salarytypen!==undefined) ? state.keyword.salarytypen : [],
        empgrade: (state.keyword.empgrade!==undefined) ? state.keyword.empgrade : [],
        employeestatus: (state.keyword.EmployeeStatus!==undefined) ? state.keyword.EmployeeStatus : [],
        demobilizestatus: (state.keyword.DemoblizeStatus !== undefined) ? state.keyword.DemoblizeStatus : [],
        AllowanceDeduction: (state.keyword.Allowance !== undefined) ? state.keyword.Allowance : [],

    }
}
  
const mapDispatchToProps = dispatch => {
    return{
        fetchPositionLists : () => dispatch(actions.fetchPositionLists()),
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
        processDynamicData: (model,type,data,func) => dispatch(actions.processDynamicData(model,type,data,func)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
        getKeywordValues: (value) => dispatch(actions.getKeywordValues(value)),
    }
}


export default connect(mapStateToProps,mapDispatchToProps)(AddEmployeeMaster);